window.theme = window.theme || {};
window.slate = window.slate || {};
window.util = {};

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 4;

/*================ utils ================*/
window.util.screenhelper = {
    breakpoint : {
        small: 480,
        medium: 768,
        large: 1024,
        widescreen: 1200
    },
    isMobile: function(){
        var result;
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            result = true;
        } else {
            result = false;
        }
        return result;
    },
    isSmall: function(){
        return screen.width < this.breakpoint.medium;
    },
    isTablet: function(){
        return !this.isSmall() && this.isMobile();
    }
}
// declarative style for slide toggling an element

window.util.datatoggle = {
    lastData: null,
    lastClick: null,
    init: function(){
        var wud = window.util.datatoggle; 

      
        $("[data-toggle]:not(.initialized)").each(function(){
            var data = $(this).data('toggle');

            if (data.single == 'true' && !wud.lastClick) {
              wud.lastClick = this;
              wud.lastData = $(data.target);
            }

            $(this).on('click', function(e){
                if (data.single == 'true' && wud.lastClick != null && wud.lastClick != this) {
                  if ($(wud.lastClick).hasClass('open')) {
                    $(wud.lastClick)
                      .removeClass('open')
                      .addClass('closed');
                      wud.lastData.slideToggle();
                  }
                  e.preventDefault();
                }
                if (!data.mobileOnly || (data.mobileOnly && util.screenhelper.isSmall())){
                    if ($(this).hasClass('closed')) {
                        $(this).removeClass('closed');
                        $(this).addClass('open');
                    } else {
                        $(this).removeClass('open');
                        $(this).addClass('closed');
                    }
                    $(data.target).slideToggle();
                    e.preventDefault();
                }
                wud.lastClick = this;
                wud.lastData = $(data.target);             
                return true;
            });
        
            if (data.initialState == "closed"){
                if ($(data.target).find('.tag--active').length > 0) {
                    $(this).addClass('open');    
                } else {
                    $(this).addClass('closed');
                    if (!data.mobileOnly || (data.mobileOnly && util.screenhelper.isSmall())){
                        $(data.target).hide();
                    }
                }
            }

            // add 300ms delay before adding the intialized class (adds transitions) 
            // to prevent animation twitching whenever selecting a new data-toggle
            var $el = $(this);
            setTimeout(function(){
                $el.addClass('enable-transitions')
            }, 100)
            $el.addClass('initialized')
        
        });
    },
    resetSingleTab: function() {
      var wud = window.util.datatoggle; 

      if ($(wud.lastClick).hasClass('open')) {
        $(wud.lastClick)
          .removeClass('open')
          .addClass('closed');
          wud.lastData.slideToggle();
      }

      $("[data-toggle].initialized").each(function(index){
        var data = $(this).data('toggle');

        if (data.single == 'true' && data.initialState == 'open') {
          wud.lastClick = this;
          wud.lastData = $(data.target);

          $(wud.lastClick)
            .removeClass('closed')
            .addClass('open');

            wud.lastData.slideToggle();
        }
      })
    }
}

window.util.findObjectByKey = function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
        if (array[i][key] === value) {
            return array[i];
        }
    }
    return null;
}
window.util.setCookie = function(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

window.util.getCookie = function(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

window.util.eraseCookie = function(name) {   
    document.cookie = name+'=; Max-Age=-99999999;';  
}

/*================ Slate ================*/
/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

    /**
     * Return an object from an array of objects that matches the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    findInstance: function(array, key, value) {
      for (var i = 0; i < array.length; i++) {
        if (array[i][key] === value) {
          return array[i];
        }
      }
    },
  
    /**
     * Remove an object from an array of objects by matching the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    removeInstance: function(array, key, value) {
      var i = array.length;
      while(i--) {
        if (array[i][key] === value) {
          array.splice(i, 1);
          break;
        }
      }
  
      return array;
    },
  
    /**
     * _.compact from lodash
     * Remove empty/false items from array
     * Source: https://github.com/lodash/lodash/blob/master/compact.js
     *
     * @param {array} array
     */
    compact: function(array) {
      var index = -1;
      var length = array == null ? 0 : array.length;
      var resIndex = 0;
      var result = [];
  
      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },
  
    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    }
  };
  
  slate.a11y = {
  
    /**
     * For use when focus shifts to a container rather than a link
     * eg for In-page links, after scroll, focus shifts to content area so that
     * next `tab` is where user expects if focusing a link, just $link.focus();
     *
     * @param {JQuery} $element - The element to be acted upon
     */
    pageLinkFocus: function($element) {
      var focusClass = 'js-focus-hidden';
  
      $element.first()
        .attr('tabIndex', '-1')
        .focus()
        .addClass(focusClass)
        .one('blur', callback);
  
      function callback() {
        $element.first()
          .removeClass(focusClass)
          .removeAttr('tabindex');
      }
    },
  
    /**
     * If there's a hash in the url, focus the appropriate element
     */
    focusHash: function() {
      var hash = window.location.hash;
  
      // is there a hash in the url? is it an element on the page?
      if (hash && document.getElementById(hash.slice(1))) {
        this.pageLinkFocus($(hash));
      }
    },
  
    /**
     * When an in-page (url w/hash) link is clicked, focus the appropriate element
     */
    bindInPageLinks: function() {
      $('a[href*=#]').on('click', function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this));
    },
  
    /**
     * Traps the focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    trapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';
  
      if (!options.$elementToFocus) {
        options.$elementToFocus = options.$container;
      }
  
      options.$container.attr('tabindex', '-1');
      options.$elementToFocus.focus();
  
      $(document).off('focusin');
  
      $(document).on(eventName, function(evt) {
        if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
          options.$container.focus();
        }
      });
    },
  
    /**
     * Removes the trap of focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    removeTrapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';
  
      if (options.$container && options.$container.length) {
        options.$container.removeAttr('tabindex');
      }
  
      $(document).off(eventName);
    },
  
  
    // Not from Slate, but fit in the a11y category
    lockMobileScrolling: function(namespace, $element) {
      if ($element) {
        var $el = $element;
      } else {
        var $el = $(document.documentElement).add('body');
      }
      $el.on('touchmove' + namespace, function () {
        return false;
      });
    },
  
    unlockMobileScrolling: function(namespace, $element) {
      if ($element) {
        var $el = $element;
      } else {
        var $el = $(document.documentElement).add('body');
      }
      $el.off(namespace);
    }
  };
  
  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
  
    $(document)
      .on('shopify:section:load', this._onSectionLoad.bind(this))
      .on('shopify:section:unload', this._onSectionUnload.bind(this))
      .on('shopify:section:select', this._onSelect.bind(this))
      .on('shopify:section:deselect', this._onDeselect.bind(this))
      .on('shopify:block:select', this._onBlockSelect.bind(this))
      .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };
  
  theme.Sections.prototype = $.extend({}, theme.Sections.prototype, {
    createInstance: function(container, constructor) {
      var $container = $(container);
      var id = $container.attr('data-section-id');
      var type = $container.attr('data-section-type');
  
      constructor = constructor || this.constructors[type];
  
      if (typeof constructor === 'undefined') {
        return;
      }
  
      var instance = $.extend(new constructor(container), {
        id: id,
        type: type,
        container: container
      });
  
      this.instances.push(instance);
    },
  
    _onSectionLoad: function(evt, subSection, subSectionId) {
      var container = subSection ? subSection : $('[data-section-id]', evt.target)[0];
  
      if (!container) {
        return;
      }
  
      this.createInstance(container);
  
      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);
  
      if (!subSection) {
        this._loadSubSections();
      }
  
      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }
    },
  
    _loadSubSections: function() {
      $('[data-subsection]').each(function(evt, el) {
        this._onSectionLoad(null, el, $(el).data('section-d'));
      }.bind(this));
    },
  
    _onSectionUnload: function(evt) {
      var instance = this._removeInstance(evt.detail.sectionId);
      if (instance && typeof instance.onUnload === 'function') {
        instance.onUnload(evt);
      }
    },
  
    _onSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (instance && typeof instance.onSelect === 'function') {
        instance.onSelect(evt);
      }
    },
  
    _onDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (instance && typeof instance.onDeselect === 'function') {
        instance.onDeselect(evt);
      }
    },
  
    _onBlockSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (instance && typeof instance.onBlockSelect === 'function') {
        instance.onBlockSelect(evt);
      }
    },
  
    _onBlockDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (instance && typeof instance.onBlockDeselect === 'function') {
        instance.onBlockDeselect(evt);
      }
    },
  
    _findInstance: function(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },
  
    _removeInstance: function(id) {
      var i = this.instances.length;
      var instance;
  
      while(i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }
  
      return instance;
    },
  
    register: function(type, constructor) {
      this.constructors[type] = constructor;
  
      $('[data-section-type=' + type + ']').each(function(index, container) {
        this.createInstance(container, constructor);
      }.bind(this));
    }
  });
  
  
  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *
   * Alternatives
   * - Accounting.js - http://openexchangerates.github.io/accounting.js/
   *
   */
  
  theme.Currency = (function() {
    var moneyFormat = '${{amount_no_decimals}}';
  
    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = slate.utils.defaultTo(precision, 2);
        thousands = slate.utils.defaultTo(thousands, ',');
        decimal = slate.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    return {
      formatMoney: formatMoney
    }
  })();
  
  
  /**
   * Image Helper Functions
   * -----------------------------------------------------------------------------
   * A collection of functions that help with basic image operations.
   *
   */
  
  theme.Images = (function() {
  
    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
      if (!src) {
        return '620x'; // default based on theme
      }
  
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
  
      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }
  
    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
      if (size == null) {
        return src;
      }
  
      if (size === 'master') {
        return this.removeProtocol(src);
      }
  
      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  
      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
  
        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }
  
      return null;
    }
  
    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }
  
    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol
    };
  })();
  
  slate.Variants = (function() {
  
    function Variants(options) {
      this.$container = options.$container;
      this.product = options.product;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentVariant = this._getVariantFromOptions();
  
      $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));

      // For PDP size dropdown
      $('.product-size-dropdown__content-option', this.$container).on('click', this._onDropdownChange.bind(this));
      // For PDP size swatches
      $('.product-size-swatches input[type="radio"]', this.$container).on('change', this._onSwatchChange.bind(this));
    }
  
    Variants.prototype = $.extend({}, Variants.prototype, {
  
      _getCurrentOptions: function() {
        var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};
  
          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');
  
              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
  
            return currentOption;
          }
        });
  
        // remove any unchecked input values if using radio buttons or checkboxes
        currentOptions = this._compact(currentOptions);
  
        return currentOptions;
      },
  
      _getVariantFromOptions: function(dropdownValues) {
        let selectedValues = null;

        // If called from PDP size dropdown, use values from button
        if (dropdownValues) {
          selectedValues = dropdownValues;
        } else {
          // Else, use the select
          selectedValues = this._getCurrentOptions();
        }

        var variants = this.product.variants;
        var found = false;
  
        variants.forEach(function(variant) {
          var match = true;
          var options = variant.options;
  
          selectedValues.forEach(function(option) {
  
            if (match) {
              match = (variant[option.index] === option.value);
            }
          });
  
          if (match) {
            found = variant;
          }
        });
  
        return found || null;
      },
  
      _onSelectChange: function() {
        var variant = this._getVariantFromOptions();

        this.$container.trigger({
          type: 'variantChange',
          variant: variant
        });
  
        if (!variant) {
          return;
        }
  
        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;
  
        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },

      // Duplicate of _onSelectChange but for PDP size dropdown
      // This is because the option values are needed to be taken from the event
      _onDropdownChange: function(event) {
        const options = {};
        
        options.value = event.currentTarget.value;
        options.index = event.currentTarget.dataset.index;
        
        const variant = this._getVariantFromOptions([options]);
        
        this.$container.trigger({
          type: 'variantChange',
          variant: variant
        });
        
        if (!variant) {
          return;
        }
        
        this.currentVariant = variant;
        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateSKU(variant);
        
        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }

        // Change price dropdown label to selected label
        const selectedLabel = event.currentTarget.dataset.selectedLabel;
        const productSizeDropdownPlaceholder = document.getElementById('productSizeDropdownPlaceholder');
        
        productSizeDropdownPlaceholder.innerText = selectedLabel;

        // Set data size attribute (for checking if there is selected size when user selects CTA button)
        const productSizeDropdown = document.getElementById('productSizeDropdown');
        productSizeDropdown.dataset.selectedSize = event.target.value;
        productSizeDropdown.dataset.selectedSku = event.target.dataset.sku;
        // Set product form size guard display to none to allow click of add to cart / join the waitlist 
        const productFormSizeGuard = document.getElementById('productFormSizeGuard');
        productFormSizeGuard.style.display = 'none';
      },

      _onSwatchChange: function(event) {
        const input = event.currentTarget;

        const options = {};
        options.value = input.value;
        options.index = input.dataset.index;

        const variant = this._getVariantFromOptions([options]);

        this.$container.trigger({
          type: 'variantChange',
          variant: variant
        });

        if (!variant) return;

        this.currentVariant = variant;

        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateSKU(variant);

        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }

        const swatchWrapper = document.querySelector('.product-size-swatches-wrapper');
        if (swatchWrapper) {
          swatchWrapper.classList.remove('size-error');

          const errorMsg = swatchWrapper.querySelector('.size-error-message');
          if (errorMsg) errorMsg.remove();
        }

        // Optional (match your dropdown behavior)
        const productFormSizeGuard = document.getElementById('productFormSizeGuard');
        if (productFormSizeGuard) {
          productFormSizeGuard.style.display = 'none';
        }
      },
  
      _updateImages: function(variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant.featured_image || {};
  
        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
          return;
        }
  
        this.$container.trigger({
          type: 'variantImageChange',
          variant: variant
        });
      },
  
      _updatePrice: function(variant) {
        if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }
  
        this.$container.trigger({
          type: 'variantPriceChange',
          variant: variant
        });
      },
  
      _updateSKU: function(variant) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }
  
        this.$container.trigger({
          type: 'variantSKUChange',
          variant: variant
        });
      },
  
      _updateHistoryState: function(variant) {
        if (!history.replaceState || !variant) {
          return;
        }
  
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({path: newurl}, '', newurl);
      },
  
      _updateMasterSelect: function(variant) {
        $(this.originalSelectorId, this.$container).val(variant.id);
      },
  
      // _.compact from lodash
      // https://github.com/lodash/lodash/blob/4d4e452ade1e78c7eb890968d851f837be37e429/compact.js
      _compact: function(array) {
        var index = -1,
            length = array == null ? 0 : array.length,
            resIndex = 0,
            result = [];
  
        while (++index < length) {
          var value = array[index];
          if (value) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
    });
  
    return Variants;
  })();
  
  
  /**
   * iFrames
   * -----------------------------------------------------------------------------
   * Wrap videos in div to force responsive layout.
   *
   * @namespace iframes
   */
  
  slate.rte = {
    wrapTable: function() {
      $('.rte table').wrap('<div class="table-wrapper"></div>');
    }
  };
  
  
  theme.Modals = (function() {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: 'modal-open',
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };
  
      this.id = id;
      this.$modal = $('#' + id);
  
      if (!this.$modal.length) {
        return false;
      }
  
      this.nodes = {
        $parent: $('html').add('body'),
        $modalContent: this.$modal.find('.modal__inner')
      };
  
      this.config = $.extend(defaults, options);
      this.modalIsOpen = false;
      this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
      this.isSolid = this.config.solid;
  
      this.init();
    }
  
    Modal.prototype.init = function() {
      var $openBtn = $(this.config.open);
  
      // Add aria controls
      $openBtn.attr('aria-expanded', 'false');
  
      $(this.config.open).on('click', this.open.bind(this));
      this.$modal.find(this.config.close).on('click', this.close.bind(this));
  
      // Close modal if a drawer is opened
      $('body').on('drawerOpen', function() {
        this.close();
      }.bind(this));
    };
  
    Modal.prototype.open = function(evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;
  
      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }
  
      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }
  
      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.$activeSource = $(evt.currentTarget);
      }
  
      if (this.modalIsOpen && !externalCall) {
        this.close();
      }
  
      this.$modal
        .prepareTransition()
        .addClass(this.config.openClass);
      this.nodes.$parent.addClass(this.config.bodyOpenClass);
  
      if (this.isSolid) {
        this.nodes.$parent.addClass(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = true;
  
      slate.a11y.trapFocus({
        $container: this.$modal,
        $elementToFocus: this.$focusOnOpen,
        namespace: 'modal_focus'
      });
  
      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'true');
      }
  
      $('body').trigger('modalOpen.' + this.id);
  
      this.bindEvents();
    };
  
    Modal.prototype.close = function() {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }
  
      // deselect any focused form elements
      $(document.activeElement).trigger('blur');
  
      this.$modal
        .prepareTransition()
        .removeClass(this.config.openClass)
        .addClass(this.config.closingClass);
      this.nodes.$parent.removeClass(this.config.bodyOpenClass);
      this.nodes.$parent.addClass(this.config.bodyClosingClass);
      var o = this;
      window.setTimeout(function() {
        o.nodes.$parent.removeClass(o.config.bodyClosingClass);
        o.$modal.removeClass(o.config.closingClass);
      }, 500); // modal close css transition
  
      if (this.isSolid) {
        this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = false;
  
      slate.a11y.removeTrapFocus({
        $container: this.$modal,
        namespace: 'modal_focus'
      });
  
      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'false').focus();
      }
  
      $('body').trigger('modalClose.' + this.id);
  
      this.unbindEvents();
    };
  
    Modal.prototype.bindEvents = function() {
      // Pressing escape closes modal
      this.nodes.$parent.on('keyup.modal', function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
  
      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.$modal.on('click.modal', this.close.bind(this));
  
        // Exception to above: clicking anywhere on the modal content will NOT close it
        this.nodes.$modalContent.on('click.modal', function(evt) {
          evt.stopImmediatePropagation();
        });
      }
    };
  
    Modal.prototype.unbindEvents = function() {
      this.nodes.$parent.off('.modal');
  
      if (this.config.closeOffContentClick) {
        this.$modal.off('.modal');
        this.nodes.$modalContent.off('.modal');
      }
    };
  
    return Modal;
  })();
  
  theme.Drawers = (function() {
    function Drawer(id, name) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name
      };
  
      this.$nodes = {
        parent: $(document.documentElement).add('body'),
        page: $('#MainContent')
      };
  
      this.$drawer = $('#' + id);
  
      if (!this.$drawer.length) {
        return false;
      }
  
      this.isOpen = false;
      this.init();
    };
  
    Drawer.prototype = $.extend({}, Drawer.prototype, {
      init: function() {
        var $openBtn = $(this.config.open);
  
        // Add aria controls
        $openBtn.attr('aria-expanded', 'false');
  
        $openBtn.on('click', this.open.bind(this));
        this.$drawer.find(this.config.close).on('click', this.close.bind(this));
      },
  
      open: function(evt) {
        if (evt) {
          evt.preventDefault();
        }
  
        if (this.isOpen) {
          return;
        }
  
        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          this.$activeSource = $(evt.currentTarget);
        }
  
        this.$drawer.prepareTransition().addClass(this.config.activeDrawer);
  
        this.$nodes.parent.addClass(this.config.openClass);
        this.isOpen = true;
  
        slate.a11y.trapFocus({
          $container: this.$drawer,
          namespace: 'drawer_focus'
        });
  
        $('body').trigger('drawerOpen.' + this.config.id);
  
        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
          this.$activeSource.attr('aria-expanded', 'true');
        }

        if(this.config.id == 'CartDrawer'){
          this.updateDrawerFooterHeight();
          cartRelatedSlider();
        }
  
        this.bindEvents();
      },

      updateDrawerFooterHeight: function() {
          const crt_footer = document.querySelector('.drawer__footer.drawer__footer--fixed');
          if (crt_footer) {
              const crt_footer_height = parseInt(crt_footer.offsetHeight + 40);
              if(crt_footer_height){
                document.documentElement.style.setProperty('--drawer-footer-height', `${crt_footer_height}px`);
              }
          }
      },
  
      close: function() {
        if (!this.isOpen) {
          return;
        }
  
        // deselect any focused form elements
        $(document.activeElement).trigger('blur');
  
        this.$drawer.prepareTransition().removeClass(this.config.activeDrawer);
  
        this.$nodes.parent.removeClass(this.config.openClass);
        this.$nodes.parent.addClass(this.config.closingClass);
        var o = this;
        window.setTimeout(function() {
          o.$nodes.parent.removeClass(o.config.closingClass);
        }, 500);
  
        this.isOpen = false;
  
        slate.a11y.removeTrapFocus({
          $container: this.$drawer,
          namespace: 'drawer_focus'
        });
  
        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
          this.$activeSource.attr('aria-expanded', 'false');
        }
  
        this.unbindEvents();
      },
  
      bindEvents: function() {
        slate.a11y.lockMobileScrolling(this.config.namespace, this.$nodes.page);
  
        // Clicking out of drawer closes it
        this.$nodes.page.on('click' + this.config.namespace, function () {
          this.close();
          return false;
        }.bind(this));
  
        // Pressing escape closes drawer
        this.$nodes.parent.on('keyup' + this.config.namespace, function(evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));
      },
  
      unbindEvents: function() {
        slate.a11y.unlockMobileScrolling(this.config.namespace, this.$nodes.page);
        this.$nodes.parent.off(this.config.namespace);
      }
    });
  
    return Drawer;
  })();
theme.cart = {
    getCart: function() {
    return $.getJSON('/cart.js');
    },

    changeItem: function(key, qty) {
    return this._updateCart({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + qty + '&id=' + key,
        dataType: 'json'
    });
    },

    addItemFromForm: function(data) {
    return this._updateCart({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json'
    });
    },

    _updateCart: function(params) {
    return $.ajax(params)
        .then(function(cart) {
        return cart;
        }.bind(this))
    },

    updateNote: function(note) {
    var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'note=' + cart.attributeToString(note),
        dataType: 'json',
        success: function(cart) {},
        error: function(XMLHttpRequest, textStatus) {}
    };

    $.ajax(params);
    },

    attributeToString: function(attribute) {
    if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
        attribute = '';
        }
    }
    return $.trim(attribute);
    }
}

// $(function() {
//     // Add a loading indicator on the cart checkout button (/cart and drawer)
//     $('body').on('click', '.cart__checkout', function() {
//     $(this).addClass('btn--loading');
//     });

//     $('body').on('change', 'textarea[name="note"]', function() {
//     var newNote = $(this).val();
//     cart.updateNote(newNote);
//     });


//     // Custom JS to prevent checkout without confirming terms and conditions
//     $('body').on('click', '.cart__checkout--ajax', function(evt) {
//     if ($('#CartAgree').is(':checked')) {
//     } else {
//         alert(theme.strings.cartTermsConfirmation);
//         $(this).removeClass('btn--loading');
//         return false;
//     }
//     });

//     $('body').on('click', '.cart__checkout--page', function(evt) {
//         if ($('#CartPageAgree').is(':checked')) {
//         } else {
//             alert(theme.strings.cartTermsConfirmation);
//             $(this).removeClass('btn--loading');
//             return false;
//         }
//     });
// });
theme.QtySelector = (function() {
    var classes = {
    input: '.js-qty__num',
    plus: '.js-qty__adjust--plus',
    minus: '.js-qty__adjust--minus',
    remove: '.js-qty__adjust--remove'
    };

    function QtySelector($el, options) {
    this.$wrapper = $el;
    this.$originalInput = $el.find('input[type="number"]');
    this.minValue = this.$originalInput.attr('min') || 1;

    var defaults = {
        namespace: null
    };

    this.options = $.extend(defaults, options);

    this.source = $('#JsQty').html();
    this.template = Handlebars.compile(this.source);

    var quantities = {
        current: this._getOriginalQty(),
        add: this._getOriginalQty() + 1,
        minus: this._getOriginalQty() - 1,
        remove: this._getOriginalQty() - this._getOriginalQty()
    };

    this.data = {
        key: this._getProductKey(),
        itemQty: quantities.current,
        itemAdd: quantities.add,
        itemMinus: quantities.minus,
        itemRemove: quantities.remove,
        inputName: this._getInputName(),
        inputId: this._getId()
    }

    // Append new quantity selector then remove original
    this.$originalInput.after(this.template(this.data)).remove();
    this.$input = this.$wrapper.find(classes.input);
    this.$plus = this.$wrapper.find(classes.plus);
    this.$minus = this.$wrapper.find(classes.minus);
    this.$remove = this.$wrapper.find(classes.remove);

    this.initEventListeners();
    };

    QtySelector.prototype = $.extend({}, QtySelector.prototype, {
    _getProductKey: function() {
        return this.$originalInput.data('id') || null;
    },

    _getOriginalQty: function() {
        return parseInt(this.$originalInput.val());
    },

    _getInputName: function() {
        return this.$originalInput.attr('name');
    },

    _getId: function() {
        return this.$originalInput.attr('id');
    },

    initEventListeners: function() {
        this.$plus.on('click', function() {
        var qty = this.validateQty(this.$input.val());
        this.addQty(qty);
        }.bind(this));

        this.$minus.on('click', function() {
        var qty = this.validateQty(this.$input.val());
        this.subtractQty(qty);
        }.bind(this));

        this.$remove.on('click', function() {
        var qty = this.validateQty(this.$input.val())
        this.removeQty(qty)
        }.bind(this));

        this.$input.on('change', function() {
        var qty = this.validateQty(this.$input.val());
        this.changeQty(qty);
        }.bind(this));
    },

    addQty: function(number) {
        var qty = number + 1;
        this.changeQty(qty);
    },

    subtractQty: function(number) {
        var qty = number - 1;
        if (qty <= this.minValue) {
        qty = this.minValue;
        }
        this.changeQty(qty);
    },

    removeQty: function(number) {
      var qty = number - number;
      this.changeQty(qty);
    },

    changeQty: function(qty) {
        this.$input.val(qty);
        $('body').trigger('qty' + this.options.namespace, [this.data.key, qty]);
    },

    validateQty: function(number) {
        if((parseFloat(number) == parseInt(number)) && !isNaN(number)) {
        // We have a valid number!
        } else {
        // Not a number. Default to 1.
        number = 1;
        }
        return parseInt(number);
    }
    });

    return QtySelector;
})();
theme.CartDrawer = (function() {
  var config = {
    namespace: '.ajaxcart'
  };

  var selectors = {
    drawer: '#CartDrawer',
    container: '#CartContainer',
    template: '#CartTemplate',
    fixedFooter: '.drawer__footer--fixed',
    fixedInnerContent: '.drawer__inner--has-fixed-footer',
    cartBubble: '.cart-link__bubble'
  };

  function CartDrawer() {
    this.status = {
      loaded: false,
      loading: false
    };

    this.qtySelectors = [];

    this.drawer = new theme.Drawers('CartDrawer', 'cart');

    // Prep handlebars template
    var source = $(selectors.template).html();
    this.template = Handlebars.compile(source);

    // Build cart on page load so it's ready in the drawer
    if (!theme.config.isIframe) {
      theme.cart.getCart().then(this.buildCart.bind(this));
    }

    this.initEventListeners();
  };

  CartDrawer.prototype = $.extend({}, CartDrawer.prototype, {
    initEventListeners: function() {
      $('body').on('updateCart' + config.namespace, this.initQtySelectors.bind(this));
      $('body').on('updateCart' + config.namespace, this.sizeFooter.bind(this));
      $('body').on('updateCart' + config.namespace, this.updateCartNotification.bind(this));
      $('body').on('drawerOpen.CartDrawer', this.sizeFooter.bind(this));

      $(window).on('resize' + config.namespace, $.debounce(150, this.sizeFooter.bind(this)));

      $('body').on('added.ajaxProduct', function() {
        theme.cart.getCart().then(function(cart) {
          this.buildCart(cart, true);
        }.bind(this));
      }.bind(this));
    },

    buildCart: function(cart, openDrawer) {
      this.loading(true);
      this.emptyCart(); 
      if (cart.item_count === 0) {
        $(selectors.container).append('<p class="appear-animation appear-delay-3">' + theme.strings.cartEmpty +'</p>');
        $(selectors.drawer).find('[data-progress-message]').hide();
        $(selectors.drawer).find('[data-progress-bar]').hide();
        $(selectors.drawer).find('[data-progress-bar]').val(0);
        
      } else {

        $(selectors.drawer).find('[data-progress-message]').show();
        $(selectors.drawer).find('[data-progress-bar]').show();

        progressbarHandle(cart);
        
        function progressbarHandle(cart){
          let cartLimit = theme.settings.cartLimit;
          let cartPrice = cart.total_price;
          let cartPercentage = ((cartLimit - cartPrice) * 100 / cartLimit);
          let percentageValue = 100 - cartPercentage;

          let limit_currency = cartLimit - cartPrice;
          let leftSpend =  theme.Currency.formatMoney(limit_currency, theme.settings.moneyFormat);

          let cartSuccessMessage = theme.strings.cartSuccessMessage;
          let cartShippingMessage = theme.strings.cartShippingMessage.replace('||amount||', leftSpend);          

          $(selectors.drawer).find('[data-progress-bar]').val(percentageValue)
          if(cartPrice >= cartLimit){
            $(selectors.drawer).find('[data-progress-message]').text(cartSuccessMessage);
          }
          else{
            $(selectors.drawer).find('[data-progress-message]').text(cartShippingMessage);
          }
        }

        const themeTagSettings = [
          theme.settings.rl_tag1,
          theme.settings.rl_tag2,
          theme.settings.rl_tag3,
          theme.settings.rl_tag4,
          theme.settings.rl_tag5
        ].filter(Boolean);
        
        var items = [];
        var item = {};
        var data = {};
        var animation_row = 1;
        let itemsArr = [];
        let firstItemTags;
        $.each(cart.items, function(index, product) {
          //console.log(cart);
          itemsArr.push(product.product_id);
          var prodImg;
          if (product.image !== null) {
            prodImg = product.image.replace(/(\.[^.]*)$/, "_180x$1");
          } else {
            prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
          }

          if (product.properties !== null) {
            $.each(product.properties, function(key, value) {
              if (key.charAt(0) === '_' || !value) {
                  delete product.properties[key];
                }
            });
          }

          function getSizeFromVariant(variant) {
            switch(variant) {
              case '6':
               return "US 2 / AU 6"
              case '8':
               return "US 4 / AU 8"
              case '10':
                return "US 6 / AU 10"
              case '12':
                return "US 8 / AU 12"
              case '14':
                return "US 10 / AU 14"
              case '16':
                return "US 12 / AU 16"
              case '18':
                return "US 14 / AU 18"
               default:
               return variant
            }
          };

          animation_row+=2;


          item = {
            key: product.key,
            url: product.url,
            img: prodImg,
            animationRow: animation_row,
            name: product.product_title.split('-')[0],
            color: product.product_title.split('-')[1],
            variation: Shopify.shop === 'bec-and-bridge-us.myshopify.com' ? getSizeFromVariant(product.variant_title) : product.variant_title,
            properties: product.properties,
            itemQty: product.quantity,
            price: theme.Currency.formatMoney(product.price, theme.settings.moneyFormat),
            compare_at_price: null,
            formatted_compare_at_price: null,
            discountedPrice: theme.Currency.formatMoney((product.price - (product.total_discount/product.quantity)), theme.settings.moneyFormat),
            discounts: product.discounts,
            discountsApplied: product.price === (product.price - product.total_discount) ? false : true,
            vendor: product.vendor,
            imgRatio: theme.settings.ImageRatio        
          };

          if (theme.settings.rl_source === 'collection') {
            loadCollectionRelatedProducts();
          }
          else if (theme.settings.rl_source === 'tags') { 
            if (index === 0) {
              fetch(`/products/${product.handle}.js`)
                .then(res => res.json())
                .then(data => {
                  firstItemTags = data.tags;
                  //console.log("First item tags:", data.tags);
                  matchTagsAndShowProducts(firstItemTags);
                });
            }
          }

          items.push(item);
        });

        animation_row+=2;

        if(Shopify.shop == 'bec-and-bridge-au.myshopify.com') {
        
          setTimeout(function(){ 
            var currency = $('span.money').attr("data-currency")

            $('#CurrencyPicker-header').on('change', function() {
              var currency = $('span.money').attr("data-currency")
          
              if(currency == 'NZD') {
                $('.js-price-currency').text('NZ')
              } else {
                $('.js-price-currency').text('')
              }
            });
      
            if(currency == 'NZD') {
              $('.js-price-currency').text('NZ')
            } else {
              $('.js-price-currency').text('')
            }
          

          
          }, 500);

          setTimeout(function(){ 
            let carttotal = cart.total_price;
            if(carttotal < 25000){
              $('#CartDrawer .shipping_msg').hide();
            }
            else if(carttotal >= 25000){
              $('#CartDrawer .shipping_msg').show();
            }
          }, 200);
          
        } else {
          setTimeout(function(){ 
            $('#CurrencyPicker-header').on('change', function() {
              var currency = $('span.money').attr("data-currency")
          
              if(currency == 'USD') {
                $('.js-price-currency').text('US')
              } else {
                $('.js-price-currency').text('')
              }
            });

            var currency = $('span.money').attr("data-currency")
            if(currency == 'USD') {
              $('.js-price-currency').text('US')
            } else {
              $('.js-price-currency').text('')
            }
          }, 1000);
        }

        function loadCollectionRelatedProducts() {
          const collectionHandle = theme.settings.rl_collection;
          //console.log(collectionHandle);
          if (!collectionHandle) return;

          fetch(`/collections/${collectionHandle}/products.json?limit=50`)
            .then(res => res.json())
            .then(data => {
              //console.log(data);
              let products = data.products || [];

              // Remove products already in cart
              products = products.filter(p => !itemsArr.includes(p.id));

              // Parse filter tags
              const filterTags = (theme.settings.rl_filter_tags || '')
                .split(',')
                .map(t => t.trim())
                .filter(Boolean);

              // Apply tag filtering ONLY if tags exist
              if (filterTags.length) {
                products = products.filter(product =>
                  product.tags.some(tag => filterTags.includes(tag))
                );
              }

              // Limit to 12 products in all cases
              products = products.slice(0, 12);

              showProducts(products);
            });
        }

        function matchTagsAndShowProducts(firstItemTags) {
          const matchedIndex = themeTagSettings.findIndex(tag =>
            firstItemTags.includes(tag)
          );

          if (matchedIndex !== -1) {
            const productsForTag = theme.settings[`rl_products${matchedIndex + 1}`];
            showProducts(productsForTag);
          }
          else {
            showProducts(theme.settings.rl_common_products);
          }
        }

        function showProducts(products) {
          //console.log(products);
          if (!products || !products.length) return;

          let html = '';
          products.forEach(product => {

              const title = product.title || '';
              const url = '/products/' + product.handle;
              const pr_image = product.images?.[0]?.src || product.images?.[0] || '';
              const sc_image = product.images?.[1]?.src || product.images?.[1] || '';
              //const price = product.price;
              //const formatted_price = theme.Currency.formatMoney(price, theme.settings.moneyFormat);
              //let formatted_compare_price = '';
              // if(product.compare_at_price){
              //   const compare_price = product.compare_at_price || '';                    
              //   if(compare_price){
              //     formatted_compare_price = theme.Currency.formatMoney(compare_price, theme.settings.moneyFormat);
              //   }
              // }

              const variants = product.variants || [];

              const rawPrice =
                product.price ??
                (variants.length ? variants[0].price : 0);

              const rawComparePrice =
                product.compare_at_price ??
                (variants.length ? variants[0].compare_at_price : null);

              const formatted_price = theme.Currency.formatMoney(
                rawPrice,
                theme.settings.moneyFormat
              );

              let formatted_compare_price = '';
              if (rawComparePrice && rawComparePrice > rawPrice) {
                formatted_compare_price = theme.Currency.formatMoney(
                  rawComparePrice,
                  theme.settings.moneyFormat
                );
              }
              
              const options = product.options || [];
              const options_size = options.length;
              const option_name = typeof options[0] === 'string' ? options[0] : options[0]?.name || '';

              const productTags = product.tags || [];

              html += `
                  <div class="grid__item grid-product cart-rp-item">
                    <div class="grid-product-inner">                        
                      <div class="grid-product__content ">
                        <div class="grid-product__image-mask">
                          <div class="slick-container"><a href="${url}" class="product-ez-image ratio-${theme.settings.ImageRatio}"><img src="${pr_image}&width=300" alt="${title}"/></a></div>
                          <a href="${url}"><div class="grid-product__secondary-image small--hide product-ez-image ratio-${theme.settings.ImageRatio}"><img src="${sc_image}&width=300" alt="${title}"/></div></a>                            
                        </div>
                      <div class="grid-product__meta">
                        <div class="grid-product__title">${title}</div>
                        `;

                        html += `
                          <div class="grid-product__price">
                            <span class="js-price-currency"></span>
                            ${formatted_price}
                        `;

                        if (product.compare_at_price) {
                          html += `
                            <span class="grid-product__price--original">
                              ${formatted_compare_price}
                            </span>
                          `;
                        }

                        html += `
                          </div>
                        `;  

                        if (options_size == 1 && option_name == "Size") {
                          html += `<div class="cart-rp-variants">`;

                          html += `<select class="cart-rp-variant-dropdown">`;

                          variants.forEach(variant => {
                            const variantTitle = variant.title;
                            const variantId = variant.id;
                            const isAvailable = variant.available;

                            html += `
                              <option value="${variantId}" ${!isAvailable ? 'disabled' : ''}>
                                ${variantTitle}${!isAvailable ? ' (Out of Stock)' : ''}
                              </option>
                            `;
                          });

                          html += `</select>
                              <button type="button" class="cart-rp-variant">ADD</button>
                          </div>`;
                        }


                        html += `
                          <div class="site-header_search-results-products-info__tag">
                        
                        `;

                        productTags.forEach(tag => {
                          html += `<div class="custom-product-tag"></div>`;
                        });

                        html += `
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>
              `;
          
          });

          const fl_HTML = html;
          // Append to cart drawer
          const cartRelatedEl = document.querySelector('.cart-related-main');
          if (cartRelatedEl) {
            document.querySelector('.cart-related-items').innerHTML = fl_HTML;
            cartRelatedSlider();
          }
        }

        //cart related products(powered by Search and Discovery)
        //shows recommended product from  first 2 cart items
        /*
        renderAllProductsSlider(itemsArr);
        async function renderAllProductsSlider(itemsArr) {
          const limitedItems = itemsArr.slice(0, 2);
          const productHTMLArr = await Promise.all(limitedItems.map(id => fetchProductHTML(id)));
          const finalHTML = productHTMLArr.join('');

          // Append to cart drawer or wherever you want
          const cartRelatedEl = document.querySelector('.cart-related-main');
          if (cartRelatedEl) {
            document.querySelector('.cart-related-items').innerHTML = finalHTML;
            cartRelatedSlider();
          }
          
        }
        function fetchProductHTML(productId, limit = 4) {
          return new Promise((resolve, reject) => {
            var requestUrl = `/recommendations/products.json?product_id=${productId}&limit=${limit}`;

            $.ajax({
              url: requestUrl,
              type: 'GET',
              success: (response) => {
                try {
                  console.log(response);
                  const products = response.products;

                  if (!products || !products.length) return resolve('');

                  let html = '';

                  products.forEach(product => {
                    const title = product.title || '';
                    const url = product.url;
                    const pr_image = product.images[0] || '';
                    const sc_image = product.images[1] || '';
                    const price = product.price;
                    const formatted_price = theme.Currency.formatMoney(price, theme.settings.moneyFormat);
                    let formatted_compare_price = '';
                    if(product.compare_at_price){
                      const compare_price = product.compare_at_price || '';                    
                      if(compare_price){
                        formatted_compare_price = theme.Currency.formatMoney(compare_price, theme.settings.moneyFormat);
                      }
                    }
                    const options_size = product.options.length;
                    const option_name = product.options[0].name;
                    const variants = product.variants;
                    const productTags = product.tags || [];

                    html += `
                        <div class="grid__item grid-product cart-rp-item">
                          <div class="grid-product-inner">                        
                            <div class="grid-product__content ">
                              <div class="grid-product__image-mask">
                                <div class="slick-container"><a href="${url}"><img src="${pr_image}&width=300" alt="${title}"/></a></div>
                                <a href="${url}"><div class="grid-product__secondary-image small--hide"><img src="${sc_image}&width=300" alt="${title}"/></div></a>                            
                              </div>
                            <div class="grid-product__meta">
                              <div class="grid-product__title">${title}</div>
                              `;

                              html += `
                                <div class="grid-product__price">
                                  <span class="js-price-currency"></span>
                                  ${formatted_price}
                              `;

                              if (product.compare_at_price) {
                                html += `
                                  <span class="grid-product__price--original">
                                    ${formatted_compare_price}
                                  </span>
                                `;
                              }

                              html += `
                                </div>
                              `;

                             
                              if (options_size == 1 && option_name == "Size") {
                                html += `<div class="cart-rp-variants">`;

                                variants.forEach(variant => {
                                  const variantTitle = variant.title;
                                  const variantId = variant.id;
                                  const isAvailable = variant.available;

                                  html += `
                                    <button 
                                      class="cart-rp-variant variant-btn${!isAvailable ? ' variant-soldout' : ''}" 
                                      data-variant-id="${variantId}" 
                                      ${!isAvailable ? 'disabled' : ''}>
                                      ${variantTitle}
                                    </button>
                                  `;
                                });

                                html += `</div>`;
                              } 

                              if (options_size == 1 && option_name == "Size") {
                                html += `<div class="cart-rp-variants">`;

                                html += `<select class="cart-rp-variant-dropdown">`;

                                variants.forEach(variant => {
                                  const variantTitle = variant.title;
                                  const variantId = variant.id;
                                  const isAvailable = variant.available;

                                  html += `
                                    <option value="${variantId}" ${!isAvailable ? 'disabled' : ''}>
                                      ${variantTitle}${!isAvailable ? ' (Out of Stock)' : ''}
                                    </option>
                                  `;
                                });

                                html += `</select>
                                    <button type="button" class="cart-rp-variant">ADD</button>
                                </div>`;
                              }


                              html += `
                                <div class="site-header_search-results-products-info__tag">
                              
                              `;

                              productTags.forEach(tag => {
                                html += `<div class="custom-product-tag"></div>`;
                              });

                              html += `
                              </div>
                            </div>
                            </div>
                          </div>
                        </div>
                    `;
                  });

                  resolve(html);
                } catch (parseError) {
                  console.error('Error parsing product HTML:', parseError);
                  resolve('');
                }
              },
              error: (err) => {
                console.error('Error fetching recommendations:', err);
                resolve('');
              }
            });
          });
        }
        */

        data = {
          items: items,
          note: cart.note,
          lastAnimationRow: animation_row,
          totalPrice: theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat),
          totalCartDiscount: cart.total_discount === 0 ? 0 : theme.strings.cartSavings.replace('[savings]', theme.Currency.formatMoney(cart.total_discount, theme.settings.moneyFormat))
        };
        
        $(selectors.container).append(this.template(data));
        this.loadCompareAtPrices(cart.items);
      }

      this.status.loaded = true;
      this.loading(false);

      if ($('body').hasClass('currencies-enabled')) {
        //theme.currencySwitcher.ajaxrefresh();
      }

      $('body').trigger('updateCart' + config.namespace, cart);

      // If specifically asked, open the cart drawer (only happens after product added from form)
      if (openDrawer === true) {
        this.drawer.open();
      }
    },

    loadCompareAtPrices: async function(cartItems) {
      for (const item of cartItems) {
        try {
          const productJson = await fetch(`/products/${item.handle}.js`).then(r => r.json());
          const variant = productJson.variants.find(v => v.id == item.variant_id);

          if (!variant || !variant.compare_at_price) continue;

          const formatted = theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.settings.moneyFormat
          );

          // Update DOM
          const el = document.querySelector(`[data-cart-item="${item.key}"] .compare-at-price`);
          if (el) {
            el.innerHTML = `<s>${formatted}</s>`;
            el.style.display = 'inline-block';
          }

        } catch(e) {
          console.warn("Compare price fetch failed:", e);
        }
      }
    },


    initQtySelectors: function() {
      this.qtySelectors = [];

      $(selectors.container).find('.js-qty').each(function(index, el) {
        var selector = new theme.QtySelector($(el), {
          namespace: '.cart-drawer'
        });
        this.qtySelectors.push(selector);
      }.bind(this));

      $('body').on('qty.cart-drawer', this.updateItem.bind(this));
    },

    updateItem: function(evt, key, qty) {
      if (this.status.loading) {
        return;
      }

      this.loading(true);

      theme.cart.changeItem(key, qty)
        .then(function(cart) {
          this.updateSuccess(cart);
        }.bind(this))
        .catch(function(XMLHttpRequest) {
          this.updateError(XMLHttpRequest)
        }.bind(this))
        .always(function() {
          this.loading(false);
        }.bind(this));
    },

    loading: function(state) {
      this.status.loading = state;

      if (state) {
        $(selectors.container).addClass('is-loading');
      } else {
        $(selectors.container).removeClass('is-loading');
      }
    },

    emptyCart: function() {
      $(selectors.container).empty();
    },

    updateSuccess: function(cart) {
      this.buildCart(cart)
    },

    updateError: function(XMLHttpRequest) {
      if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
        console.warn(XMLHttpRequest.responseJSON.description);
      }
    },

    // Update elements after cart is updated
    sizeFooter: function() {
      // Stop if our drawer doesn't have a fixed footer
      if (!$(selectors.drawer).hasClass('drawer--has-fixed-footer')) {
        return;
      }

      // Elements are reprinted regularly so selectors are not cached
      var $cartFooter = $(selectors.drawer).find(selectors.fixedFooter).removeAttr('style');
      var $cartInner = $(selectors.drawer).find(selectors.fixedInnerContent).removeAttr('style');
      var cartFooterHeight = $cartFooter.outerHeight();

      $cartInner.css('bottom', cartFooterHeight);
      $cartFooter.css('height', cartFooterHeight);
    },

      updateCartNotification: function(evt, cart) {
      if (cart.items.length > 0) {
        $(selectors.cartBubble).addClass('cart-link__bubble--visible');
      } else {
        $(selectors.cartBubble).removeClass('cart-link__bubble--visible');
      }
      // Also update the element with the current item count
      $('.js-cart-item-count').text(`(${cart.item_count})`);
      $(selectors.cartBubble).text(`(${cart.item_count})`);
    }
  });

  
  return CartDrawer;
})();
theme.AjaxProduct = (function() {
    var status = {
      loading: false
    };
  
    function ProductForm($form) {
      this.$form = $form;
      this.$addToCart = this.$form.find('.add-to-cart');
  
      if (this.$form.length) {
        this.$form.on('submit', this.addItemFromForm.bind(this));
      }
    };
  
    ProductForm.prototype = $.extend({}, ProductForm.prototype, {
      addItemFromForm: function(evt, callback){
        evt.preventDefault();
  
        if (status.loading) {
          console.warn('already adding item to cart | bail');
          return;
        }
  
        // Loading indicator on add to cart button
        this.$addToCart.addClass('btn--loading');
  
        status.loading = true;
  
        var data = this.$form.serialize();
  
        theme.cart.addItemFromForm(data)
          .then(function(product) {
            this.success(product);
          }.bind(this))
          .catch(function(XMLHttpRequest) {
            this.error(XMLHttpRequest)
          }.bind(this))
          .always(function() {
            status.loading = false;
            this.$addToCart.removeClass('btn--loading');
          }.bind(this));
      },
  
      success: function(product) {
        this.$form.find('.errors').remove();
        $('body').trigger('added.ajaxProduct');
      },
  
      error: function(XMLHttpRequest) {
        this.$form.find('.errors').remove();
  
        if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
          console.warn(XMLHttpRequest.responseJSON.description);
  
          this.$form.prepend('<div class="errors text-center">' + XMLHttpRequest.responseJSON.description + '</div>');
        }
      }
    });
  
    return ProductForm;
  })();
theme.collapsibles = (function() {

    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner'
    };
  
    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height'
    };
  
    var isTransitioning = false;
  
    function init() {
      $(selectors.trigger).each(function() {
        var $el = $(this);
        var state = $el.hasClass(classes.open);
        $el.attr('aria-expanded', state);
      });

      $("body").on('click', "[collapse-trigger-on-click]", function(e){
        e.preventDefault();
        $(this).next().find('.collapsible-trigger').trigger('click');
      });
  
      // Event listeners (hack for modals)
      $('body, .modal__inner').on('click', selectors.trigger, function() {
        if (isTransitioning) {
          return;
        }
  
        isTransitioning = true;
  
        var $el = $(this);
        var isOpen = $el.hasClass(classes.open);
        var moduleId = $el.attr('aria-controls');
        var $module = $('#' + moduleId);
        var height = $module.find(selectors.moduleInner).outerHeight();
        var isAutoHeight = $el.hasClass(classes.autoHeight);
  
        // If isAutoHeight, set the height to 0 just after setting the actual height
        // so the closing animation works nicely
        if (isOpen && isAutoHeight) {
          setTimeout(function() {
            height = 0;
            setTransitionHeight($module, height, isOpen, isAutoHeight);
          }, 0);
        }
  
        if (isOpen && !isAutoHeight) {
          height = 0;
        }
  
        $el
          .attr('aria-expanded', !isOpen)
          .toggleClass(classes.open, !isOpen);
  
        setTransitionHeight($module, height, isOpen, isAutoHeight);
      });
    }
  
    function setTransitionHeight($module, height, isOpen, isAutoHeight) {
      $module
        .removeClass(classes.hide)
        .prepareTransition()
        .css('height', height)
        .toggleClass(classes.open, !isOpen);
  
      if (!isOpen && isAutoHeight) {
        var o = $module;
        window.setTimeout(function() {
          o.css('height','auto');
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }
  
    return {
      init: init
    };
  })();
theme.headerNav = (function() {

    var $parent = $(document.documentElement).add('body');
    var $page = $('#MainContent');
    var selectors = {
      wrapper: '.header-wrapper',
      siteHeader: '.site-header',
      searchBtn: '.js-search-header',
      closeSearch: '.js-search-header-close',
      searchContainer: '.site-header__search-container',
      searchResults: '.site-header__search-results',
      searchInput: '.site-header__search-input',
      logoContainer: '.site-header__logo',
      logo: '.site-header__logo img',
      navigation: '.site-navigation',
      navContainerWithLogo: '.header-item--logo',
      navLinks: '.site-nav__link',
      navDropdownLinks: '.site-nav__dropdown-link--second-level',
  
      hasDropdownClass: 'site-nav--has-dropdown',
      hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
      reverseLastDropdown: 'header-item--reverse'
    };
  
    var config = {
      namespace: '.siteNav',
      wrapperOverlayed: false,
      overlayedClass: 'is-light',
      stickyEnabled: false,
      stickyMobile: false,
      stickyActive: false,
      stickyClass: 'site-header--stuck',
      stickyClassMobile: 'site-header--stuck__mobile-only',
      stickyClassHide: 'scrolled-down',
      stickyHideElements: [
        '.site-header__logo',
        '.site-header__search-form',
        '.site-nav__link.js-search-header',
      ],
      openTransitionClass: 'site-header--opening',
      lastScroll: 0
    };
  
    // Elements used in resize functions, defined in init
    var $window;
    var $navContainerWithLogo;
    var $logoContainer;
    var $nav;
    var $wrapper;
    var $siteHeader;
  
    function init() {
      $window = $(window);
      $navContainerWithLogo = $(selectors.navContainerWithLogo);
      $logoContainer = $(selectors.logoContainer);
      $nav = $(selectors.navigation);
      $wrapper = $(selectors.wrapper);
      $siteHeader = $(selectors.siteHeader);
  
      var enableFitNav = $(selectors.navigation).hasClass('site-nav--activate-compress');
  
      if (enableFitNav) {
        fitNav();
        $window.on('load' + config.namespace, fitNav);
        $window.on('resize' + config.namespace, $.debounce(150, fitNav));
      }
  
      config.stickyEnabled = $siteHeader.data('sticky');
      if (config.stickyEnabled) {
        config.wrapperOverlayed = $wrapper.hasClass(config.overlayedClass);
        stickyHeader();
      }
  
      accessibleDropdowns();
      searchDrawer();

      $window.on('load' + config.namespace, resizeLogo);
      $window.on('resize' + config.namespace, $.debounce(150, resizeLogo));

      if (selectors) {
        $(selectors.searchInput).on('input', $.debounce(1000, function (e) {
          const s_term = e.target.value.trim();
          if (s_term == "") {
            $('.site-header__search-results-container').removeClass('active');
            document.querySelector('.site-header__search_collections').classList.add('active');            
          }
          else{
            instantSearchSuggestion(e.target.value);
          }
        }));
      }
    }

    function unload() {
      $(window).off(config.namespace);
      $(selectors.searchBtn).off(config.namespace);
      $(selectors.closeSearch).off(config.namespace);
      $parent.off(config.namespace);
      $(selectors.navLinks).off(config.namespace);
      $(selectors.navDropdownLinks).off(config.namespace);
    }
  
    function searchDrawer() {
      $(selectors.searchBtn).on('click' + config.namespace, function(evt) {
        evt.preventDefault();
        openSearchDrawer();
      });
  
      $(selectors.closeSearch).on('click' + config.namespace, function() {
        closeSearchDrawer();
      });
    }
  
    function openSearchDrawer() {
 
      $('.site-header-sticky').css('height', '80vh');
      $('.site-header').css('height', '100vh');

      $(selectors.searchContainer).addClass('is-active');
      $parent.addClass('js-drawer-open js-drawer-open--search');
      slate.a11y.trapFocus({
        $container: $(selectors.searchContainer),
        namespace: 'header_search',
        $elementToFocus: $(selectors.searchContainer).find('input')
      });
  
      // If sticky is enabled, scroll to top on mobile when close to it
      // so you don't get an invisible search box
      if (theme.config.bpSmall && config.stickyEnabled && config.lastScroll < 300) {
        window.scrollTo(0,0);
      }
  
      // Bind events
      slate.a11y.lockMobileScrolling(config.namespace);
  
      // Clicking out of container closes it
      $page.on('click' + config.namespace, function () {
        closeSearchDrawer();
        return false;
      });
  
      $parent.on('keyup' + config.namespace, function(evt) {
        if (evt.keyCode === 27) {
          closeSearchDrawer();
        }
      });

    }
  
    function closeSearchDrawer() {
      
      $('.site-header-sticky').css('height', '85px');
      $('.site-header').css('height', 'auto');
      // deselect any focused form elements
      $(document.activeElement).trigger('blur');
  
      $parent.removeClass('js-drawer-open js-drawer-open--search').off(config.namespace);
      $(selectors.searchContainer).removeClass('is-active');
      $('.site-header__search-results-container').removeClass('active');

      slate.a11y.removeTrapFocus({
        $container: $(selectors.searchContainer),
        namespace: 'header_search'
      });
  
      slate.a11y.unlockMobileScrolling(config.namespace);
      $page.off('click' + config.namespace);
      $parent.off('keyup' + config.namespace);

      // Clear search input
      $(selectors.searchInput).val('');
    }
  
    function resizeLogo() {
      // Using .each() as there can be a reversed logo too
      $(selectors.logo).each(function() {
        var $el = $(this),
            logoWidthOnScreen = $el.width(),
            containerWidth = $el.closest('.grid__item').width();
        // If image exceeds container, let's make it smaller
        if (logoWidthOnScreen > containerWidth) {
          $el.css('maxWidth', containerWidth);
        }
        else {
          $el.removeAttr('style');
        }
      });
    }
  
    function fitNav() {
      // Measure children of site nav on load and resize.
      // If wider than parent (minus logo), switch to mobile nav.
      // Subtract 20 from width to account for inline-block spacing
      var availableNavSpace = $navContainerWithLogo.width() - $logoContainer.outerWidth() - 10;
      var navItemWidth = 0;
      $nav.find('> li').each(function() {
        var $el = $(this);
        if (!$el.hasClass('site-nav--compress__menu')) {
          // Round up to be safe
          navItemWidth += Math.ceil($(this).width());
        }
      });
  
      // Set class to make third level nav float to left so it stays in the screen
      if ((availableNavSpace - navItemWidth) < 180) {
        $navContainerWithLogo.addClass(selectors.reverseLastDropdown)
      } else {
        $navContainerWithLogo.removeClass(selectors.reverseLastDropdown)
      }
  
      if (navItemWidth > availableNavSpace) {
        $wrapper.addClass('site-nav--compress');
      } else {
        $wrapper.removeClass('site-nav--compress');
      }
    }
  
    function accessibleDropdowns() {
      var hasActiveDropdown = false;
      var hasActiveSubDropdown = false;
  
      // Open/hide top level dropdowns
      $(selectors.navLinks).on('focusin' + config.namespace, function() {
        if (hasActiveDropdown) {
          closeSecondLevelDropdown();
        }
  
        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }
  
        if ($(this).parent().hasClass(selectors.hasDropdownClass)) {
          $(this).addClass('is-focused');
          hasActiveDropdown = true;
        }
      });
  
      // Force remove focus on sitenav links because focus sometimes gets stuck
      $(selectors.navLinks).on('mouseleave' + config.namespace, function() {
        closeSecondLevelDropdown();
      });
  
      // Open/hide sub level dropdowns
      $(selectors.navDropdownLinks).on('focusin' + config.namespace, function() {
        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }
  
        if ($(this).parent().hasClass(selectors.hasSubDropdownClass)) {
          $(this).addClass('is-focused');
          hasActiveSubDropdown = true;
        }
      });
  
      // Private dropdown methods
      function closeSecondLevelDropdown() {
        $(selectors.navLinks).blur().removeClass('is-focused');
      }
  
      function closeThirdLevelDropdown() {
        $(selectors.navDropdownLinks).removeClass('is-focused');
      }
    }
  
    function stickyHeader() {
      config.lastScroll = 0;
      $siteHeader.wrap('<div class="site-header-sticky"></div>');

      stickyHeaderHeight();
      $window.on('resize' + config.namespace, $.debounce(50, stickyHeaderHeight));
      $window.on('scroll' + config.namespace, $.throttle(15, stickyHeaderScroll));
    }
  
    function stickyHeaderHeight() {
      $('.site-header-sticky').css('height', $siteHeader.outerHeight(true));

      //var headerHeight = $siteHeader.outerHeight(true);
      //$('.site-header-sticky').css('height', headerHeight);      

      //document.documentElement.style.setProperty('--sticky-offset', parseFloat(headerHeight + 10) + 'px');
    }
  
    function stickyHeaderScroll() {
      var scroll = $window.scrollTop();
      var threshold = 250;
  
      if (scroll > threshold) {
        if (config.stickyActive) {
          return;
        }
  
        config.stickyActive = true;

        config.stickyMobile = $siteHeader.data('sticky-mobile');
        if(config.stickyMobile){
          $siteHeader.addClass(config.stickyClassMobile);
        } else {
          $siteHeader.addClass(config.stickyClass);
        }
        
        if (config.wrapperOverlayed) {
          $wrapper.removeClass(config.overlayedClass);
        }
  
        // Add open transition class after element is set to fixed
        // so CSS animation is applied correctly
        setTimeout(function() {
          $siteHeader.addClass(config.openTransitionClass);
        }, 50);
      } else {
        if (!config.stickyActive) {
          return;
        }
  
        config.stickyActive = false;

        config.stickyMobile = $siteHeader.data('sticky-mobile');
        if(config.stickyMobile){
          $siteHeader.removeClass(config.openTransitionClass).removeClass(config.stickyClassMobile);
        } else {
          $siteHeader.removeClass(config.openTransitionClass).removeClass(config.stickyClass);
        }
  
        if (config.wrapperOverlayed) {
          $wrapper.addClass(config.overlayedClass);
        }
      }
  
      config.lastScroll = scroll;
    }
  
    return {
      init: init,
      unload: unload
    };
  })();
theme.articleImages = (function() {

    var cache = {};
  
    function init() {
      cache.$rteImages = $('.rte--indented-images');
  
      if (!cache.$rteImages.length) {
        return;
      }
  
      $(window).on('load', setImages);
    }
  
    function setImages() {
      cache.$rteImages.find('img').each(function() {
        var $el = $(this);
        var attr = $el.attr('style');
  
        // Check if undefined or float: none
        if (!attr || attr == 'float: none;') {
          // Remove grid-breaking styles if image isn't wider than parent
          if ($el.width() < cache.$rteImages.width()) {
            $el.addClass('rte__no-indent');
          }
        }
      });
    }
  
    return {
      init: init
    };
  })();
theme.backButton = (function() {

    function init() {
      if (!document.referrer || !$('.return-link').length || !window.history.length) {
        return;
      }
  
      //$('.return-link').on('click', backHistory);
    }
  
    function backHistory() {
      var referrerDomain = urlDomain(document.referrer);
      var shopDomain = urlDomain(document.url);
  
      if (shopDomain === referrerDomain) {
        history.back();
        return false;
      }
    }
  
    function urlDomain(url) {
      var    a      = document.createElement('a');
             a.href = url;
      return a.hostname;
    }
  
    return {
      init: init
    };
  })();
theme.Slideshow = (function() {
    this.$slideshow = null;
  
    var classes = {
      next: 'is-next',
      init: 'is-init',
      header: 'header-wrapper',
      wrapper: 'slideshow-wrapper',
      slideshow: 'slideshow',
      currentSlide: 'slick-current',
      pauseButton: 'slideshow__pause',
      isPaused: 'is-paused'
    };
  
    function slideshow(el, args) {
      this.$slideshow = $(el);
      this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
      this.$pause = this.$wrapper.find('.' + classes.pauseButton);
  
      this.settings = {
        accessibility: true,
        arrows: args.arrows ? true : false,
        dots: args.dots ? true : false,
        draggable: true,
        touchThreshold: 5,
        pauseonHover: false,
        autoplay: this.$slideshow.data('autoplay'),
        autoplaySpeed: this.$slideshow.data('speed')
      };
  
      this.$slideshow.on('init', this.init.bind(this));
  
      this.$slideshow.slick(this.settings);
  
      this.$pause.on('click', this._togglePause.bind(this));
    }
  
    slideshow.prototype = $.extend({}, slideshow.prototype, {
      init: function(event, obj) {
        this.$slideshowList = obj.$list;
        this.$slickDots = obj.$dots;
        this.$allSlides = obj.$slides;
        this.slideCount = obj.slideCount;
  
        this.$slideshow.addClass(classes.init);
        // this._currentSlide().addClass('is-first');
        this._a11y();
      },
      destroy: function() {
        this.$slideshow.slick('unslick');
      },
  
      // Playback
      _play: function() {
        this.$slideshow.slick('slickPause');
        $(classes.pauseButton).addClass('is-paused');
      },
      _pause: function() {
        this.$slideshow.slick('slickPlay');
        $(classes.pauseButton).removeClass('is-paused');
      },
      _togglePause: function() {
        var slideshowSelector = this._getSlideshowId(this.$pause);
        if (this.$pause.hasClass(classes.isPaused)) {
          this.$pause.removeClass(classes.isPaused);
          $(slideshowSelector).slick('slickPlay');
        } else {
          this.$pause.addClass(classes.isPaused);
          $(slideshowSelector).slick('slickPause');
        }
      },
  
      // Helpers
      _getSlideshowId: function($el) {
        return '#Slideshow-' + $el.data('id');
      },
      _activeSlide: function() {
        return this.$slideshow.find('.slick-active');
      },
      _currentSlide: function() {
        return this.$slideshow.find('.slick-current');
      },
      _nextSlide: function(index) {
        return this.$slideshow.find('.slideshow__slide[data-slick-index="' + index + '"]');
      },
  
      // a11y fixes
      _a11y: function() {
        var $list = this.$slideshowList;
        var autoplay = this.settings.autoplay;
  
        // Remove default Slick aria-live attr until slider is focused
        $list.removeAttr('aria-live');
  
        // When an element in the slider is focused
        // pause slideshow and set aria-live
        $(classes.wrapper).on('focusin', function(evt) {
          if (!$(classes.wrapper).has(evt.target).length) {
            return;
          }
  
          $list.attr('aria-live', 'polite');
          if (autoplay) {
            this._pause();
          }
        }.bind(this));
  
        // Resume autoplay
        $(classes.wrapper).on('focusout', function(evt) {
          if (!$(classes.wrapper).has(evt.target).length) {
            return;
          }
  
          $list.removeAttr('aria-live');
          if (autoplay) {
            this._play();
          }
        }.bind(this));
      }
    });
  
    return slideshow;
  })();
theme.announcementBar = (function() {
    var selectors = {
      announcementBar: '.announcement',
      announcementText: '.announcement__text',
      announcementClose: '.announcement__close'
    };
  
    function init() {
      if (!$(selectors.announcementClose).length || theme.config.isIframe) {
        return;
      }
  
      if (theme.config.hasSessionStorage && sessionStorage[announcementBarText()] !== 'hidden') {
        window.setTimeout(function() {
          announcementBarShow();
        }, 100);
      }
  
      // Probably in the editor, so show it anyway
      if (!theme.config.hasSessionStorage) {
        window.setTimeout(function() {
          announcementBarShow();
        }, 100);
      }
  
      $(selectors.announcementClose).on('click', function(evt) {
        evt.preventDefault();
        announcementBarClose();
      });
    }
  
    function announcementBarShow() {
      $(selectors.announcementBar).removeClass('announcement--closed');
      var barHeight = $(selectors.announcementBar).height();
      $(selectors.announcementBar).addClass('announcement--opening').prepareTransition().css({height: barHeight});
      $(selectors.announcementClose).css({height: barHeight});
    }
  
    function announcementBarClose() {
      if (theme.config.hasSessionStorage) {
        sessionStorage.setItem(announcementBarText(), 'hidden');
      }
  
      var barHeight = $(selectors.announcementBar).height();
  
      $(selectors.announcementBar).addClass('announcement--closed');
    }
  
    function announcementBarText() {
      return $(selectors.announcementText).data('text');
    }
  
    return {
      init: init
    };
  })();
theme.currencySwitcher = (function() {
  
    var selectors = {
      dataDiv: '#CurrencyData',
      picker: '.currency-input'
    };
  
    var data = {};

    function getURLCurrency(){
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        var currency;
        for(var i = 0; i < hashes.length; i++)
        {
            hash = hashes[i].split('=');
            if (hash[0] == "currency"){
              currency = hash[1];
              break;
            }
        }
        return currency
    }

    function cleanCurrencyFromURL() {
      var parameter = "currency"
      var url = window.location.search;
      var urlParts = url.split('?');
    
      if (urlParts.length >= 2) {
        // Get first part, and remove from array
        var urlBase = urlParts.shift();
    
        // Join it back up
        var queryString = urlParts.join('?');
    
        var prefix = encodeURIComponent(parameter) + '=';
        var parts = queryString.split(/[&;]/g);
    
        // Reverse iteration as may be destructive
        for (var i = parts.length; i-- > 0; ) {
          // Idiom for string.startsWith
          if (parts[i].lastIndexOf(prefix, 0) !== -1) {
            parts.splice(i, 1);
          }
        }

        if (parts.length > 0) {
          url = urlBase + '?' + parts.join('&');
        } else {
          url = "";
        }
      }

      var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + url;
      window.history.pushState({path:newurl},'',newurl);
    }
  
    function init() {
      var $dataDiv = $(selectors.dataDiv);
  
      if (!$dataDiv.length) {
        return;
      }
  
      $primaryPicker = $('#CurrencyPicker-header');
      $secondaryPicker = $('#CurrencyPicker-footer');
  
      // Keep primary and secondary currency pickers in sync
      if ($secondaryPicker.length) {
        $secondaryPicker.on('change', function() {
          $primaryPicker.val($(this).val());
        });
  
        $primaryPicker.on('change', function() {
          $secondaryPicker.val($(this).val());
        });
      }
  
      data = {
        currency: $dataDiv.data('shop-currency'),
        default: $dataDiv.data('default-currency'),
        format: $dataDiv.data('format'),
        moneyFormat: $dataDiv.data('money-format'),
        moneyCurrencyFormat: $dataDiv.data('money-currency-format')
      };
  
      Currency.format = data.format;
  
      // Rely on the shop's currency format, not Shopify defaults (in case merchant changes it)
      Currency.money_format[data.currency] = data.moneyFormat;
      Currency.money_with_currency_format[data.currency] = data.moneyCurrencyFormat;
      
      // Fix for customer account page
      $('span.money span.money').each(function() {
        $(this).parents('span.money').removeClass('money');
      });
      //console.log(data.currency);
      // Save current price
      $('span.money').each(function() {
        $(this).attr('data-currency-' + data.currency, $(this).html());
      });


      var forceCurrency = getURLCurrency();
      checkCookie(forceCurrency);
      // clean up URL 
      if (forceCurrency){
        cleanCurrencyFromURL();
      }
      
      $(selectors.picker).val(Currency.currentCurrency).on('change', refresh);
      
      // update mobile currency links
      $("[data-currency-link]").each(function(){
        var $el = $(this);
        var baseUrl = $el.attr('href');
        var selectedCurrency = $el.data('currency-code');
        var paramkey = window.location.search.indexOf("?") >= 0 ? "&currency=" : "?currency=";
        $el.attr('href', baseUrl + window.location.pathname + window.location.search + paramkey + selectedCurrency);
      });

    }
  
    function refresh() {
      var $option = $(selectors.picker).find("option:checked")
      var altsrc = $option.data('alt-src');
      if (altsrc){
        var paramkey = window.location.search.indexOf("?") >= 0 ? "&currency=" : "?currency=";
        window.location = window.location.protocol + "//" + $option.data('alt-src') + window.location.pathname + window.location.search + paramkey + $option.val();
      } else {
        var newCurrency = $(selectors.picker).val();
        Currency.convertAll(Currency.currentCurrency, newCurrency);
      }
    }
  
    function ajaxrefresh() {
      var newCurrency = $(selectors.picker).val();
      // Ajax cart always returns shop's currency, not what theme settings defines
      Currency.convertAll(data.currency, newCurrency);
    }
  
    function checkCookie(forceValue) {
      var cookieCurrency = forceValue? forceValue : Currency.cookie.read();
      //console.log(cookieCurrency);
      if (cookieCurrency == null) {
        if (data.currency !== data.default) {
          Currency.convertAll(data.currency, data.default);
        }
        else {
          Currency.currentCurrency = data.default;
        }
      } else if ($(selectors.picker).length && $(selectors.picker).find('option[value=' + cookieCurrency + ']').length === 0) {
        // If the cookie value does not correspond to any value in the currency dropdown
        Currency.currentCurrency = data.currency;
        Currency.cookie.write(data.currency);
      }
      else if (cookieCurrency === data.currency) {
        Currency.currentCurrency = data.currency;
      }
      else {
        Currency.convertAll(data.currency, cookieCurrency);
      }
    }
  
    return {
      init: init,
      refresh: refresh,
      ajaxrefresh: ajaxrefresh
    };
  })();
theme.initQuickShop = function() {
    $('.quick-product__btn').each(function() {
      var productId = $(this).data('product-id');
      var modalId = 'QuickShopModal-' + productId;
      var modalName = 'quick-modal-' + productId;
      new theme.Modals(modalId, modalName);
    });
  };
theme.videoModal = function() {
    var videoModalPlayer = null;
    var videoOptions = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        branding: 0,
        cc_load_policy: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      }
    };
  
    var selectors = {
      triggers: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]'
    };
  
    if (!$(selectors.triggers).length) {
      return;
    }
  
    var modal = new theme.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true,
      solid: true
    });
  
    // We have at least one video that may open in a modal. Prep YouTube API
    window.loadYouTube();
    $('body').on('youTubeReady', function() {
      $(selectors.triggers).on('click', startVideoOnClick);
    });
  
    function startVideoOnClick(evt) {
      evt.preventDefault();
      var $el = $(this);
  
      // get video ID from URL
      var videoId = getYoutubeVideoId($el.attr('href'));
  
      var args = $.extend({}, videoOptions, {
        videoId: videoId
      });
  
      // Disable plays inline on mobile
      args.playerVars.playsinline = theme.config.bpSmall ? 0 : 1;
  
      var videoModalPlayer = new YT.Player('VideoHolder', args);
      modal.open();
  
      $('body').on('modalClose.VideoModal', function() {
        // Slight timeout so it is destroyed after the modal closes
        setTimeout(function() {
          videoModalPlayer.destroy();
        }, 500); // modal close css transition
      });
    }
  
    function getYoutubeVideoId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return (match&&match[7].length==11)? match[7] : false;
    }
  };
  
theme.customerTemplates = (function() {

    function initEventListeners() {
      // Show reset password form
      $('#RecoverPassword').on('click', function(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
  
      // Hide reset password form
      $('#HideRecoverPasswordLink').on('click', function(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
    }
  
    /**
     *
     *  Show/Hide recover password form
     *
     */
    function toggleRecoverPasswordForm() {
      $('#RecoverPasswordForm').toggleClass('hide');
      $('#CustomerLoginForm').toggleClass('hide');
    }
  
    /**
     *
     *  Show reset password success message
     *
     */
    function resetPasswordSuccess() {
      var $formState = $('.reset-password-success');
  
      // check if reset password form was successfully submitted
      if (!$formState.length) {
        return;
      }
  
      // show success message
      $('#ResetSuccess').removeClass('hide');
    }
  
    /**
     *
     *  Show/hide customer address forms
     *
     */
    function customerAddressForm() {
      var $newAddressForm = $('#AddressNewForm');
  
      if (!$newAddressForm.length) {
        return;
      }
  
      // Initialize observers on address selectors, defined in shopify_common.js
      if (Shopify) {
        new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
          hideElement: 'AddressProvinceContainerNew'
        });
      }
  
      // Initialize each edit form's country/province selector
      $('.address-country-option').each(function() {
        var formId = $(this).data('form-id');
        var countrySelector = 'AddressCountry_' + formId;
        var provinceSelector = 'AddressProvince_' + formId;
        var containerSelector = 'AddressProvinceContainer_' + formId;
  
        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
          hideElement: containerSelector
        });
      });
  
      // Toggle new/edit address forms
      $('.address-new-toggle').on('click', function() {
        $newAddressForm.toggleClass('hide');
      });
  
      $('.address-edit-toggle').on('click', function() {
        var formId = $(this).data('form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
      });
  
      $('.address-delete').on('click', function() {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');
  
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
          Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
        }
      });
    }
  
    /**
     *
     *  Check URL for reset password hash
     *
     */
    function checkUrlHash() {
      var hash = window.location.hash;
  
      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
  
    return {
      init: function() {
        checkUrlHash();
        initEventListeners();
        resetPasswordSuccess();
        customerAddressForm();
      }
    };
  })();
theme.Product = (function() {
    var youtubeReady;
    var videos = {};
    var youtubePlayers = [];
    var youtubeVideoOptions = {
      height: '480',
      width: '850',
      playerVars :{
        autohide: 0,
        autoplay: 1,
        branding: 0,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      },
      events: {
        onReady: onVideoPlayerReady,
        onStateChange: onVideoStateChange
      }
    };
  
    var vimeoReady;
    var vimeoPlayers = [];
    var vimeoVideoOptions = {
      byline: false,
      title: false,
      portrait: false,
      loop: true
    };
  
    var selectors = {
      videoParent: '.product__video-wrapper'
    };
  
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable',
      currentSlide: 'slick-current',
      productVideo: 'product__video'
    };
  
    function onVideoPlayerReady(evt) {
      var $player = $(evt.target.a);
      var playerId = $player.attr('id');
      youtubePlayers[playerId] = evt.target; // update stored player
      var player = youtubePlayers[playerId];
  
      setParentAsLoading($player);
  
      if (videos[playerId].style === 'muted') {
        youtubePlayers[playerId].mute().playVideo().pauseVideo();
      } else {
        setParentAsLoaded($player);
      }
  
      // If first slide or only photo, start video
      if ($player.closest('.' + classes.currentSlide).length || $player.data('image-count') === 1) {
        youtubePlayers[playerId].playVideo();
        initCheckVisibility(playerId);
      }
    }
  
    function initCheckVisibility(playerId) {
      // Add out of view pausing
      videoVisibilityCheck(playerId);
      $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
    }
  
    function videoVisibilityCheck(id) {
      var playerId;
  
      if (typeof id === 'string') {
        playerId = id;
      } else {
        // Data comes in as part of the scroll event
        playerId = id.data.id;
      }
  
      if (theme.isElementVisible($('#' + playerId))) {
        playVisibleVideo(playerId);
      } else {
        pauseHiddenVideo(playerId);
      }
    }
  
    function playVisibleVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
        youtubePlayers[id].playVideo();
      }
    }
  
    function pauseHiddenVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
        youtubePlayers[id].pauseVideo();
      }
    }
  
    function onVideoStateChange(evt) {
      var $player = $(evt.target.a);
      var playerId = $player.attr('id');
      var player = youtubePlayers[playerId];
  
      switch (evt.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (videos[playerId].attemptedToPlay) {
            setParentAsLoaded($player);
            setVideoToBeInteractedWith($player);
          }
          break;
        case 0: // ended
          player.playVideo();
          break;
        case 1: // playing
          setParentAsLoaded($player);
          break;
        case 3: // buffering
          videos[playerId].attemptedToPlay = true;
          break;
      }
    }
  
    function setParentAsLoading($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.loading);
    }
  
    function setParentAsLoaded($el) {
      $el
        .closest(selectors.videoParent)
        .removeClass(classes.loading)
        .addClass(classes.loaded);
    }
  
    function setVideoToBeInteractedWith($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.interactable);
    }
  
    function Product(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
  
      this.inModal = $container.closest('.modal').length;
      this.$modal;
  
      this.settings = {
        enableHistoryState: $container.data('enable-history-state') || false,
        namespace: '.product-' + sectionId,
        inventory: $container.data('inventory') || false,
        modalInit: false,
        lazyLoadModalContent: $container.data('lazyload-content') || false,
        modalContentLoaded: false,
        slickInitialized: false,
        hasColorSwatches: false,
        hasImages: true,
        hasMultipleImages: false,
        imageSize: '620x',
        productLayout: theme.settings.productLayout
      };
  
      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = '.product-' + sectionId + '-modal';
        this.$modal = $('#QuickShopModal-' + sectionId);
      }
  
      this.classes = {
        onSale: 'on-sale',
        disabled: 'disabled',
        isModal: 'is-modal'
      };
  
      this.selectors = {
        productJson: 'ProductJson-' + sectionId,
  
        video: 'ProductVideo-' + sectionId,
        photoThumbs: '.product__thumb-' + sectionId,
        thumbSlider: '#ProductThumbs-' + sectionId,
        mainSlider: '#ProductPhotos-' + sectionId,
        relatedProductSlider: '#RelatedProductSlider',
        productVideo: '.product__video',
  
        priceWrapper: '.product__price-wrap-' + sectionId,
        price: '#ProductPrice-' + sectionId,
        comparePrice: '#ComparePrice-' + sectionId,
        priceA11y: '#PriceA11y-' + sectionId,
        comparePriceA11y: '#ComparePriceA11y-' + sectionId,
        sku: '#Sku-' + sectionId,
        inventory: '#ProductInventory-' + sectionId,
  
        addToCart: '#AddToCart-' + sectionId,
        addToCartText: '#AddToCartText-' + sectionId,

        joinTheWaitlist: '#JoinTheWaitlist-' + sectionId,
  
        originalSelectorId: '#ProductSelect-' + sectionId,
        singleOptionSelector: '.variant__input-' + sectionId,
        variantColorLabel: '#VariantColorLabel-' + sectionId,
  
        formContainer: '#AddToCartForm-' + sectionId,

        // add preorder settings here
        preorderContainer: '#preorderContainer',
        preorderMessageLineItemProperty: '#preorderMessageLineItemProperty',
      };
  
      if (!$('#' + this.selectors.productJson).html()) {
        return;
      }
  
      this.productObject = JSON.parse(document.getElementById(this.selectors.productJson).innerHTML);
  
      this.$mainSlider = $(this.selectors.mainSlider);
      this.$thumbSlider = $(this.selectors.thumbSlider);
      this.$relatedProductSlider = $(this.selectors.relatedProductSlider);
      this.$firstProductImage = this.$mainSlider.find('img').first();
      if (!this.$firstProductImage.length) {
        this.settings.hasImages = false;
      }
  
      this.init();
    }
  
    Product.prototype = $.extend({}, Product.prototype, {
      init: function() {
        if (this.inModal) {
          this.$container.addClass(this.classes.isModal);
          $('body').on('modalOpen.QuickShopModal-' + this.sectionId, this.openModalProduct.bind(this));
          $('body').on('modalClose.QuickShopModal-' + this.sectionId, this.closeModalProduct.bind(this));
        }
  
        this.productTabs();
        this.stringOverrides();
        this.setImageSizes();
        this.initQtySelector();
        this.initAjaxProductForm();
        this.initVariants();
        this.initImageSwitch();
  
        if (!this.inModal) {
          this.checkIfVideos();
          this.createImageCarousels();
        }
      },

      productTabs: function() {

        $('.product-tab__content').on('init', function(event, slick){
          $('.recently-viewed, .related-product').show();
        });
        
        $('.product-tab__menu').click(function() {
            var tabMenu = $(this).attr('data-tab');

            $('.product-tab__menu').removeClass('active');
            $('.product-tab__content').removeClass('active');

            $(this).addClass('active');
            $("#"+tabMenu).addClass('active');
        }) 
      },
  
      stringOverrides: function() {
        theme.productStrings = theme.productStrings || {};
        $.extend(theme.strings, theme.productStrings);
      },
  
      setImageSizes: function() {
        if (!this.settings.hasImages) {
          return;
        }
  
        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.$firstProductImage[0].currentSrc;
  
        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }

      },

      checkInventory: function(variant){

        if(variant.type == "variantChange"){
            variant = variant.variant;
        }

        // get updated inventory quanity via MindArc Api
        // https://shopifyap21app.testarc.com.au/info/variant_stock
        // for production use ^ url
        // var apiAddress = "https://shopifyap21app.testarc.com.au/info/variant_stock?shop=";

        // if(Shopify.shop == 'bec-bridge-development.myshopify.com'){
        //   apiAddress = "https://shopifyap21app-dev.testarc.com.au/info/variant_stock?shop=";
        // }

        // var apiURL = apiAddress+Shopify.shop+"&variant_sku="+variant.sku;
        // var that = this;
        // $.ajax({
        //     url: apiURL,
        //     type: 'GET',
        //     dataType: 'json', // added data type
        //     success: function(res) {
        //       if (res.success) {
        //         // update inventory
        //         var data = {};
        //         if(!res.has_stock){
        //             variant.available = false;
        //             data = {
        //               variant: variant
        //             }
        //             // remove out of stock message
        //             $('.stockMsg').hide();
        //         }else{
        //             data = {
        //               variant: variant
        //             }
        //             $('.stockMsg').show();
        //         }
        //         that.updateCartButton(data);
        //         that.updateBackInStock(data);
        //       }
        //     }
        // });
            
        
      },
  
      initVariants: function() {

        var options = {
          $container: this.$container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          product: this.productObject
        };

        
        var url = new URL(window.location.href);
        var variantParam = url.searchParams.get("variant");
        var variantSku;

        // if variant is in url param
        if(variantParam){

            variantParam = parseInt(variantParam);            
            var variantSku = options.product.variants.find(function(item) {
              return item.id == variantParam;
            });

        } else {
            // Get the correct variant on page load
            if (options.product.available == true) {
              for (index in options.product.variants) {
                let variant = options.product.variants[index];
                if (variant.available) {
                  variantSku = variant;
                  break;
                }
              }
            }
            else {
              variantSku = options.product.variants[0];
            }
        }

        if (variantSku == undefined) {
            variantSku = options.product.variants[0].id;
        }

        this.checkInventory(variantSku);
        this.$container.on('variantChange' + this.settings.namespace, this.checkInventory.bind(this));

  
        if ($(this.selectors.variantColorLabel).length) {
          this.settings.hasColorSwatches = true;
          this.$colorSwatchLabel = $(this.selectors.variantColorLabel);
          this.colorOptionIndex = this.$colorSwatchLabel.data('option-index');
          this.$container.on('variantChange' + this.settings.namespace, this.updateColorName.bind(this));
        }
  
        this.variants = new slate.Variants(options);
        this.$container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
        this.$container.on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this));
        this.$container.on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this));
        if ($(this.selectors.sku).length) {
          this.$container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
        }
        if (this.settings.inventory) {
          this.$container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
        }
      },
  
      // Variant change functions
      updateColorName: function(evt) {
        var variant = evt.variant;
        // Temp fix to prevent JS error. Still need to update color label if variant does not exist
        if (variant && variant.options) {
          var colorName = variant.options[this.colorOptionIndex];
          this.$colorSwatchLabel.text(colorName);
        } else {
          this.$colorSwatchLabel.empty();
        }
      },
  
      updateCartButton: function(evt) {
        var variant = evt.variant; 
        // add preorder functionality here $(this.selectors.preorderContainer)
        if (variant) {
          if (variant.available) {

            // Available, enable the submit button and change text
            $(this.selectors.addToCart).css("display", "block");
            $(this.selectors.joinTheWaitlist).css("display", "none");
            $(this.selectors.formContainer).removeClass('wishlist_hidden');

            $(this.selectors.addToCart).removeClass(this.classes.disabled).prop('disabled', false);
            var variant_quantity_obj = util.findObjectByKey(variants, "variant_id", variant.id);
            if (variant_quantity_obj.inventory_policy == 'continue' && variant_quantity_obj.qty <= 0) {
              $(this.selectors.addToCartText).html(theme.strings.preorder);
              // preorder product here
              $(this.selectors.preorderContainer).html(theme.strings.preorderMessage).addClass('show');
              if ($(this.selectors.preorderMessageLineItemProperty).length) {
                $(this.selectors.preorderMessageLineItemProperty).val(theme.strings.preorderMessageLineItemProperty);
              }
           } else {
              $(this.selectors.addToCartText).html(theme.strings.addToCart);
              $(this.selectors.preorderContainer).html('').removeClass('show'); // close preorder message
              if ($(this.selectors.preorderMessageLineItemProperty).length) {
                $(this.selectors.preorderMessageLineItemProperty).val('');
              }
            }
          } else {
            // Product waitlist
            // Join the waitlist button
            $(this.selectors.joinTheWaitlist).css("display", "block");
            $(this.selectors.joinTheWaitlist).removeAttr("disabled");
            $(this.selectors.addToCart).css("display", "none");
            $(this.selectors.formContainer).addClass('wishlist_hidden');

            const product = JSON.parse(document.getElementById(this.selectors.productJson).innerHTML);

            $(`#JoinTheWaitlist-${this.sectionId}`).click(() => openWaitlistModal(product.id, variant.id))
            $(`#JoinKlaviyoComingSoon-${this.sectionId}`).click(() => openKlaviyoComingSoonModal(product.id, variant.id))
            
            $(this.selectors.preorderContainer).html('').removeClass('show'); // close preorder message
            if ($(this.selectors.preorderMessageLineItemProperty).length) {
              $(this.selectors.preorderMessageLineItemProperty).val('');
            }
          }
        } else {
          // The variant doesn't exist, disable submit button
          $(this.selectors.addToCart).addClass(this.classes.disabled).prop('disabled', true);
          $(this.selectors.addToCartText).html(theme.strings.unavailable);
          $(this.selectors.preorderContainer).html('').removeClass('show'); // close preorder message
          if ($(this.selectors.preorderMessageLineItemProperty).length) {
            $(this.selectors.preorderMessageLineItemProperty).val('');
          }
          $(this.selectors.formContainer).removeClass('wishlist_hidden');
        }
      },

      updatePrice: function(evt) {
        var variant = evt.variant;
  
        if (variant) {
          // Regular price
          $(this.selectors.price).html(theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat)).show();
        
          // Sale price, if necessary
          if (variant.compare_at_price > variant.price) {
            $(this.selectors.comparePrice).html(theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat));
            $(this.selectors.priceWrapper).removeClass('hide');
            $(this.selectors.price).addClass(this.classes.onSale);
            $(this.selectors.comparePriceA11y).attr('aria-hidden', 'false');
            $(this.selectors.priceA11y).attr('aria-hidden', 'false');
          } else {
            $(this.selectors.priceWrapper).addClass('hide');
            $(this.selectors.price).removeClass(this.classes.onSale);
            $(this.selectors.comparePriceA11y).attr('aria-hidden', 'true');
            $(this.selectors.priceA11y).attr('aria-hidden', 'true');
          }
  
          if ($('body').hasClass('currencies-enabled')) {
            //theme.currencySwitcher.ajaxrefresh();
          }
        }
      },
  
      updateSku: function(evt) {
        var variant = evt.variant;
        var newSku = '';
  
        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }
  
          $(this.selectors.sku).html(newSku);
        }
      },
  
      updateInventory: function(evt) {
        var variant = evt;
        if(evt.type == "variantChange"){
            variant = evt.variant;
        }
        
        if (variant.available){
          var showInventory = true;
          var $inventoryLabel = $(this.selectors.inventory);
  
          var variant_qty_data = util.findObjectByKey(variants, "variant_id", variant.id);
          variant.inventory_quantity = variant_qty_data.qty;
    
          if (!showInventory) {
            $inventoryLabel.addClass('hide');
          } else {
            $inventoryLabel
              .removeClass('hide')
              .text(theme.strings.stockLabel.replace('[count]', variant.inventory_quantity));
          }
        }
      },
  
      updateVariantImage: function(evt) {
        var variant = evt.variant;
        var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);        
  
        var $newImage = $('.product__thumb[data-id="' + variant.featured_image.id + '"]');
        var imageIndex = this._slideIndex($newImage.closest('.product__thumb-item'));
  
        // If there is no index, slider is not initalized
        if (typeof imageIndex === 'undefined') {
          return;
        }
  
        this.$mainSlider.slick('slickGoTo', imageIndex);
      },
  
      // Image/thumbnail toggling
      initImageSwitch: function() {
        if (!$(this.selectors.photoThumbs).length) {
          return;
        }
  
        var self = this;
  
        $(this.selectors.photoThumbs).on('click', function(evt) {
          evt.preventDefault();
        });
      },
  
      checkIfVideos: function() {
        var $productVideos = this.$mainSlider.find(this.selectors.productVideo);
  
        // Stop if there are 0 videos
        if (!$productVideos.length) {
          return false;
        }
  
        var videoTypes = [];
  
        $productVideos.each(function() {
          var type = $(this).data('video-type');
  
          if (videoTypes.indexOf(type) < 0) {
            videoTypes.push(type);
          }
        });
  
        // Load YouTube API if not already loaded
        if (videoTypes.indexOf('youtube') > -1) {
          if (!theme.config.youTubeReady) {
            window.loadYouTube();
            $('body').on('youTubeReady' + this.settings.namespace, function() {
              this.loadYoutubeVideos($productVideos);
            }.bind(this));
          } else {
            this.loadYoutubeVideos($productVideos);
          }
        }
  
        // Load Vimeo API if not already loaded
        if (videoTypes.indexOf('vimeo') > -1) {
          if (!vimeoReady) {
            window.loadVimeo();
            $('body').on('vimeoReady' + this.settings.namespace, function() {
              this.loadVimeoVideos($productVideos);
            }.bind(this))
          } else {
            this.loadVimeoVideos($productVideos);
          }
        }
  
        // Add mp4 video players
        if (videoTypes.indexOf('mp4') > -1) {
          this.loadMp4Videos($productVideos);
        }
  
        return videoTypes;
      },
  
      loadMp4Videos: function($videos) {
        $videos.each(function() {
          var $el = $(this);
          if ($el.data('video-type') != 'mp4') {
            return;
          }
  
          var id = $el.attr('id');
          var videoId = $el.data('video-id');
  
          videos[this.id] = {
            type: 'mp4',
            divId: id,
            style: $el.data('video-style')
          };
        });
      },
  
      loadVimeoVideos: function($videos) {
        $videos.each(function() {
          var $el = $(this);
          if ($el.data('video-type') != 'vimeo') {
            return;
          }
  
          var id = $el.attr('id');
          var videoId = $el.data('video-id');
  
          videos[this.id] = {
            type: 'vimeo',
            divId: id,
            id: videoId,
            style: $el.data('video-style'),
            width: $el.data('video-width'),
            height: $el.data('video-height')
          };
        });
  
        // Create a new player for each Vimeo video
        for (var key in videos) {
          if (videos[key].type != 'vimeo') {
            continue;
          }
  
          var args = $.extend({}, vimeoVideoOptions, videos[key]);
          vimeoPlayers[key] = new Vimeo.Player(videos[key].divId, args);
        }
  
        vimeoReady = true;
      },
  
      autoplayVimeoVideo: function(id) {
        // Do not autoplay on mobile though
        if (!theme.config.bpSmall) {
          this.requestToPlayVimeoVideo(id);
        } else {
          // Set as loaded on mobile so you can see the image
          var $player = $('#' + id);
          setParentAsLoaded($player);
        }
      },
  
      requestToPlayVimeoVideo: function(id) {
        // The slider may initialize and attempt to play the video before
        // the API is even ready, because it sucks.
  
        var $player = $('#' + id);
        setParentAsLoading($player);
  
        if (!vimeoReady) {
          // Wait for the trigger, then play it
          $('body').on('vimeoReady' + this.settings.namespace, function() {
            this.playVimeoVideo(id);
          }.bind(this))
          return;
        }
  
        this.playVimeoVideo(id);
      },
  
      playVimeoVideo: function(id) {
        vimeoPlayers[id].play();
  
        if (videos[id].style === 'muted') {
          vimeoPlayers[id].setVolume(0);
        }
  
        var $player = $('#' + id);
        setParentAsLoaded($player);
      },
  
      stopVimeoVideo: function(id) {
        if (!theme.config.vimeoReady) {
          return;
        }
  
        if (id) {
          vimeoPlayers[id].pause();
        } else {
          for (key in vimeoPlayers) {
            if (typeof vimeoPlayers[key].pause === 'function') {
              vimeoPlayers[key].pause();
            }
          }
        }
      },
  
      loadYoutubeVideos: function($videos) {
        $videos.each(function() {
          var $el = $(this);
          if ($el.data('video-type') != 'youtube') {
            return;
          }
  
          var id = $el.attr('id');
          var videoId = $el.data('youtube-id');
  
          videos[this.id] = {
            type: 'youtube',
            id: id,
            videoId: videoId,
            style: $el.data('video-style'),
            width: $el.data('video-width'),
            height: $el.data('video-height'),
            attemptedToPlay: false
          };
        });
  
        // Create a player for each YouTube video
        for (var key in videos) {
          if (videos[key].type === 'youtube') {
            if (videos.hasOwnProperty(key)) {
              var args = $.extend({}, youtubeVideoOptions, videos[key]);
  
              if (args.style === 'muted') {
                // default youtubeVideoOptions, no need to change anything
              } else {
                args.playerVars.controls = 1;
                args.playerVars.autoplay = 0;
              }

              youtubePlayers[key] = new YT.Player(key, args);
            }
          }
        }
  
        youtubeReady = true;
      },
  
      requestToPlayYoutubeVideo: function(id, forcePlay) {
        if (!theme.config.youTubeReady) {
          return;
        }
  
        var $player = $('#' + id);
        setParentAsLoading($player);
  
        // If video is requested too soon, player might not be ready.
        // Set arbitrary timeout to request it again in a second
        if (typeof youtubePlayers[id].playVideo != 'function') {
          var o = this;
          setTimeout(function() {
            o.playYoutubeVideo(id, forcePlay);
          }, 1000);
          return;
        }
  
        this.playYoutubeVideo(id, forcePlay);
      },
  
      playYoutubeVideo: function (id, forcePlay) {
        var $player = $('#' + id);
        setParentAsLoaded($player);
        if (typeof youtubePlayers[id].playVideo === 'function') {
          youtubePlayers[id].playVideo();
        }
  
        // forcePlay is sent as true from beforeSlideChange so the visibility
        // check isn't fooled by the next slide positioning
        if (!forcePlay) {
          initCheckVisibility(id);
        }
      },
  
      stopYoutubeVideo: function(id) {
        if (!theme.config.youTubeReady) {
          return;
        }
  
        if (id && youtubePlayers[id]) {
          youtubePlayers[id].pauseVideo();
          $(window).off('scroll.' + id);
        } else {
          for (key in youtubePlayers) {
            if (typeof youtubePlayers[key].pauseVideo === 'function') {
              youtubePlayers[key].pauseVideo();
              $(window).off('scroll.' + key);
            }
          }
        }
      },
  
      playMp4Video: function(id) {
        var $player = $('#' + id);
        setParentAsLoaded($player);
  
        $player[0].play();
      },
  
      stopMp4Video: function(id) {
        if (id) {
          $('#' + id)[0].pause();
        } else {
          // loop through all mp4 videos to stop them
          for (var key in videos) {
            if (videos[key].type === 'mp4') {
              var player = $('#' + videos[key].divId)[0];
              if (typeof player.pause === 'function') {
                player.pause();
              }
            }
          }
        }
      },

      createImageCarousels: function() {
        let productLayout = this.settings.productLayout;
        let isNew;
        if(productLayout == 'new'){
          isNew = true;
        }
        else{
          isNew = false;
        }
        let isMobile = window.util.screenhelper.isMobile() || window.util.screenhelper.isSmall();

        if (!isNew && (!this.$thumbSlider.length || $(this.selectors.photoThumbs).length < 2)) { 
          // Single product image. Init video if it exists
          var $video = $('.product-image-main').find('.product__video');
          if ($video.length) {
            this.initVideo($video);
          }
          return;
        }
  
        this.settings.hasMultipleImages = true;
  
        // Set starting slide (for both sliders)
        var $activeSlide = this.$mainSlider.find('.starting-slide');
        var startIndex = this._slideIndex($activeSlide);
  
        // Lame way to prevent duplicate event listeners
        this.$mainSlider.off('init');
        this.$mainSlider.off('beforeChange');
        this.$mainSlider.on('init', this.mainSlideInit.bind(this));
        this.$mainSlider.on('beforeChange', this.beforeSlideChange.bind(this));

        if ( $(this.$mainSlider).hasClass('product-slideshow') ) {
          if ( $(window).width() < 590 ) {

            // Dots & Arrows settings for mobile product page carousel
            var sliderDots = false,
                sliderArrows = true;
          }
          else {
            var sliderDots = false,
                sliderArrows = true;
          }
        }
        else {
          var sliderDots = false,
              sliderArrows = false;          
        }

        var responsiveSettings = [];

        // New design (vertical → horizontal switch)
        if (isNew) {
          responsiveSettings.push({
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              vertical: false,
              verticalSwiping: false
            }
          });
        }

        //Old design (mobile tweaks only)
        if (!isNew) {
          responsiveSettings.push({
            breakpoint: 590,
            settings: {
              slidesToShow: 1
            }
          });
        }
  
        var hasThumbs = !isNew && this.$thumbSlider.length && $(this.selectors.photoThumbs).length >= 2;
  
        this.$mainSlider.slick({
          asNavFor: hasThumbs ? this.selectors.thumbSlider : null,
          infinite: false,
          arrows: sliderArrows,
          dots: isNew ? true : sliderDots,
          initialSlide: startIndex,
          prevArrow: `<img class="sslick-prev-arrow" src="${this.$mainSlider.attr('data-prev-arrow')}" alt="Previous">`,
          nextArrow: `<img class="sslick-next-arrow" src="${this.$mainSlider.attr('data-next-arrow')}" alt="Next">`,
          vertical: isNew,
          verticalSwiping: isNew,
          speed: 500,
          responsive: responsiveSettings
        });

        if (isNew) {
          let scrolling = false;

          this.$mainSlider.on('wheel', function(e) {
            if ($(window).width() <= 1024) return;
            e.preventDefault();

            if (!$(this).hasClass('slick-initialized')) return;
            if (scrolling) return;

            scrolling = true;

            if (e.originalEvent.deltaY < 0) {
              $(this).slick('slickPrev');
            } else {
              $(this).slick('slickNext');
            }

            setTimeout(() => {
              scrolling = false;
            }, 500);
          });
        }
  
        if (!isNew && hasThumbs) {
          var thumbnailsVertical = this.$thumbSlider.data('position') === 'beside' ? true : false;
    
          this.$thumbSlider.slick({
            asNavFor: this.selectors.mainSlider,
            slidesToShow: thumbnailsVertical ? 3 : 5,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            vertical: thumbnailsVertical,
            verticalSwiping: thumbnailsVertical,
            focusOnSelect: true,
            infinite: false,
            customHeightMatching: thumbnailsVertical,
            customSlideAdvancement: true,
            initialSlide: startIndex
          });
        }

        this.$relatedProductSlider.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: false,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                infinite: false,
                slidesToShow: 1.9
              }
            }
          ]
        });
  
        this.settings.slickInitialized = true;
      },
  
      destroyImageCarousels: function() {
        if (!this.settings.slickInitialized) {
          return;
        }
  
        if (this.$mainSlider) {
          this.$mainSlider.slick('unslick');
        }
  
        if (this.$thumbSlider) {
          this.$thumbSlider.slick('unslick');
        }
  
        this.settings.slickInitialized = false;
      },
  
      mainSlideInit: function(event, slick) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find('.' + classes.currentSlide);
        var $video = $currentSlide.find('.' + classes.productVideo);
  
        if (!$video.length) {
          return;
        }
  
        this.initVideo($video);
      },
  
      initVideo: function($video) {
        var videoType = $video.data('video-type');
        var divId = $video.attr('id');
  
        if (videoType === 'mp4' && videos[divId].style === 'muted') {
          this.playMp4Video(divId);
        }
  
        if (videoType === 'youtube') {
          if (youtubeReady && videos[divId].style === 'muted') {
            this.requestToPlayYoutubeVideo(divId);
          }
        }
  
        if (videoType === 'vimeo') {
          if (vimeoReady && videos[divId].styles === 'muted') {
            // Because the vimeo API might not be ready, this autoplay check
            // is handled elsewhere
            this.autoplayVimeoVideo(divId);
          }
        }
  
        // Hacky way to trigger resetting the slider layout in modals
        if (this.inModal) {
          this.resizeSlides();
        }
      },
  
      getVideoType: function($video) {
        return $video.data('video-type');
      },
  
      getVideoId: function($video) {
        return $video.attr('id');
      },
  
      beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find('.' + classes.currentSlide);
        var $prevVideo = $currentSlide.find('.product__video');
        var $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');
        var $nextVideo = $nextSlide.find('.product__video');
  
        // Pause any existing slide video
        if (currentSlide !== nextSlide && $prevVideo.length) {
          var prevVideoType = this.getVideoType($prevVideo);
          var prevVideoId = this.getVideoId($prevVideo);
  
          if (prevVideoId) {
            if (prevVideoType === 'youtube') {
              this.stopYoutubeVideo(prevVideoId);
            }
  
            if (prevVideoType === 'mp4') {
              this.stopMp4Video(prevVideoId);
            }
  
            if (prevVideoType === 'vimeo') {
              this.stopVimeoVideo(prevVideoId);
            }
          }
        }
  
        // Prep next slide video
        if ($nextVideo.length) {
          var nextVideoType = this.getVideoType($nextVideo);
          var nextVideoId = this.getVideoId($nextVideo);
  
          // Prep Vimeo with a backup in case the API isn't ready
          if (nextVideoId && nextVideoType === 'vimeo') {
            if (vimeoReady) {
              if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                this.autoplayVimeoVideo(nextVideoId);
              }
            } else {
              $('body').on('vimeoReady' + this.settings.namespace, function() {
                if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                  this.autoplayVimeoVideo(nextVideoId);
                }
              }.bind(this))
            }
          }
  
          // Prep YouTube with a backup in case API isn't ready
          if (nextVideoId && nextVideoType === 'youtube') {
            if (youtubeReady) {
              if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                this.requestToPlayYoutubeVideo(nextVideoId, true);
              }
            } else {
              $('body').on('youTubeReady' + this.settings.namespace, function() {
                if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                  this.requestToPlayYoutubeVideo(nextVideoId, true);
                }
              }.bind(this))
            }
          }
  
          // Autoplay muted MP4 videos
          if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
            if (nextVideoType === 'mp4') {
              this.playMp4Video(nextVideoId);
            }
          }
  
          // Set unmuted videos to loaded state
          if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style != 'muted') {
            setParentAsLoaded($('#' + nextVideoId));
          }
        }

      },
  
      resizeSlides: function() {
        if (!this.settings.hasMultipleImages) {
          return;
        }
  
        $(window).trigger('resize');
        setTimeout(function() {
          this.$mainSlider.slick('setPosition');
          this.$thumbSlider.slick('setPosition');
        }.bind(this), 500); // same timing as modal open transition
      },
  
      _slideIndex: function($el) {
        return $el.data('index');
      },
  
      // Ajax cart and qty
      initQtySelector: function() {
        this.$container.find('.js-qty').each(function() {
          new theme.QtySelector($(this), {
            namespace: '.product'
          });
        });
      },
  
      initAjaxProductForm: function() {
        if (theme.settings.cartType === 'drawer') {
          new theme.AjaxProduct($(this.selectors.formContainer));
        }
      },
  
      openModalProduct: function() {
        if (!this.settings.modalInit) {
          this.loadModalContent();
          this.createImageCarousels();
          this.settings.modalInit = true;
        }
  
        this.resizeSlides();
      },
  
      closeModalProduct: function() {
        this.stopYoutubeVideo();
        this.stopVimeoVideo();
        this.stopMp4Video();
      },
  
      loadModalContent: function() {
        if (this.settings.modalContentLoaded) {
          return;
        }
  
        // Load images
        var imageCount = $(this.selectors.photoThumbs).length * 2; // thumbs and main images
        var loadCount = 0;
  
        this.$modal.find('img[data-modal-lazy]').each(function(i, img) {
          var $el = $(img);
          var image = $el.data('modal-lazy');
          $el.attr('src', image);
          loadCount++;
  
          if (loadCount == imageCount) {
            this.settings.modalContentLoaded = true;
          }
        }.bind(this));
  
        // Load videos if they exist
        var videoTypes = this.checkIfVideos();
  
        // Lazyload mp4 videos similar to images
        if (videoTypes && videoTypes.indexOf('mp4') > -1) {
          this.$modal.find('.product__video[data-video-type="mp4"]').each(function(i, video) {
            var $el = $(video);
            var src = $el.data('video-src');
            var source = document.createElement('source');
            source.setAttribute('src', src);
            $el.append(source);
          }.bind(this));
        }
      },
  
      onUnload: function() {
        this.$container.off(this.settings.namespace);
        $('body').off(this.settings.namespace);
        this.destroyImageCarousels();
      },

    });
  
    return Product;
  })();

var nextSVGWhite = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right slick-next" viewBox="0 0 284.49 498.98" style="fill: #fff;"><defs><style>.cls-1{fill:#fff}</style></defs><path class="cls-1" d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"/></svg>';
var prevSVGWhite = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left slick-prev" viewBox="0 0 284.49 498.98" style="fill: #fff;"><defs><style>.cls-1{fill:#fff}</style></defs><path class="cls-1" d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"/></svg>';


$(document).ready(function() {
  getStockMsg(); 
  var myVar;
  $(".variant-input-wrap input:radio").click(function() {
    clearTimeout(myVar);
    $('select[name="id"]').trigger('change');
    myVar = setTimeout(function(){ 
      getStockMsg(); 
    }, 100);
    
  });

  // product main image fancybox 
  const pm_images = document.querySelectorAll("[data-fancybox='gallery']");
  const gallery = Array.from(pm_images).map(el => ({
    src: el.dataset.src,
    type: "image"
  }));
  pm_images.forEach((el, index) => {
    el.addEventListener("click", function (e) {
      e.preventDefault();

      Fancybox.show(gallery, {
        startIndex: index,
        theme: "light",
        Carousel: {
          Thumbs: false,
          fadeEffect: false,
          Keyboard: {
            ArrowUp: "",
            ArrowDown: "",
          },
          Images: {
            zoom: false,
            wheel: false,
            panzoom: true
          },
          Toolbar: {
            display: {
              left: [],
              middle: [],
              right: ["close"],
            },
          },

          on: {
            keydown: (fancybox, event) => {
              if (event.key === "ArrowUp" || event.key === "ArrowDown") {
                event.preventDefault();
                event.stopPropagation();
              }
            },
          },
        }
      });

    }, true);
  });
});

function openKlaviyoComingSoonModal(productId, variantId) {
  MicroModal.show("productKlaviyoComingSoonModal");

  // Reset waitlist form
  // $("#waitlistForm").off("submit");
  $("#klaviyoComingSoonEmail").val("");
  $("#klaviyoComingSoonMobile").val("");
  $("#klaviyoComingSoonSuccess").css("display", "none");
  $("#klaviyoComingSoonForm").css("display", "block");  
}

function openWaitlistModal(productId, variantId) {
  MicroModal.show("productWaitlistModal"); 

  // Reset waitlist form
  // $("#waitlistForm").off("submit");
  $("#waitlistEmail").val("");
  $("#newsAndUpdateCheckbox").prop("checked", false);
  $("#waitlistSuccess").css("display", "none");
  
  // Submit waitlist form
  // $("#waitlistForm").on("submit", function(event) {
  //   event.preventDefault();
    
  //   const waitlistEmail = $("#waitlistEmail").val();
  //   const newsAndUpdateCheckbox = $("#newsAndUpdateCheckbox").prop("checked");
  //   const listId = Shopify.shop === "bec-and-bridge-au.myshopify.com" ? "VPXHzp" : "UARXAc";
  //   const accountId = Shopify.shop === "bec-and-bridge-au.myshopify.com" ? "WaHYYq" : "Uv4da6";

  //   const waitlistData = {
  //     a: accountId,
  //     email: waitlistEmail,
  //     variant: variantId,
  //     product: productId,
  //     platform: "shopify",
  //     subscribe_for_newsletter: newsAndUpdateCheckbox,
  //     g: listId,
  //   };

  //   $.ajax({
  //     type: "POST",
  //     url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
  //     data: waitlistData,
  //     success: function(response){
  //       $("#waitlistSuccess").css("display", "block");
  //       $("#waitlistEmail").val("");
  //     },
  //     error: function (error) {
  //       $("#waitlistSuccess").css("display", "none");
  //       console.error(error);
  //     }
  //   });
  // }); 
}

function handleProductFormSizeGuardClick() {
  const isSizeSelected = checkIfSizeSelected();

  if (isSizeSelected === false) {
    const productSizeDropdownContent = document.getElementById("productSizeDropdownContent");
    if (productSizeDropdownContent) {
      productSizeDropdownContent.classList.add("product-size-dropdown__content--show");
    }

    // SWATCH BEHAVIOR (NEW)
    const swatchWrapper = document.querySelector('.product-size-swatches-wrapper');

    if (swatchWrapper) {
      swatchWrapper.classList.add('size-error');
      let errorMsg = swatchWrapper.querySelector('.size-error-message');

      if (!errorMsg) {
        errorMsg = document.createElement('div');
        errorMsg.className = 'size-error-message';
        errorMsg.innerText = 'Please choose your size';

        swatchWrapper.appendChild(errorMsg);
      }
    }

    return;
  };

  // If for any unexpected reason that size guard is still blocking cta buttons, hide it
  const productFormSizeGuard = document.getElementById('productFormSizeGuard');
  productFormSizeGuard.style.display = 'none';
}

function checkIfSizeSelected() {
  const selectedSwatch = document.querySelector('.product-size-swatches input:checked');
  if (selectedSwatch) {
    return true;
  }

  const productSizeDropdown = document.getElementById('productSizeDropdown');
  if (productSizeDropdown && productSizeDropdown.dataset.selectedSize) {
    return true;
  }
  return false;
};

function getStockMsg() {

  var stockMsg = $('select[name="id"] option:selected').data('stock-msg');
  if (stockMsg === undefined) {
    $('.stockMsg').text('');
  } else {
    $('.stockMsg').text(stockMsg);
  }
}


theme.Collection = (function() {
    var classes = {
      tags: '.tags',
      activeTag: 'tag--active',
      taggedFilter: 'tagged-filter',
      taggedFilterClear: 'tagged-filter-clear',
      clearfilterID: "#clearfilters",
      filterWrapper: "#filter-wrapper",
      filterWrapperTrigger: "#filter-wrapper-toggle-trigger"
    };
  
    function Collection(container) {
      this.container = container;
      this.sectionId = $(container).attr('data-section-id');
      this.namespace = '.collection-' + this.sectionId;
  
      var $heroImageContainer = $(container).find('.collection-hero');
      if ($heroImageContainer.length) {
        theme.loadImageSection($heroImageContainer);
      }

      $(document).on('click', classes.filterWrapperTrigger, function(e){
        e.preventDefault();
        $(this).toggleClass('open');
        $(classes.filterWrapper).slideToggle(300);
      })
  
      // Ajax pagination
      $(window).on('popstate', function(state) {
        if (state) {
          this.getNewCollectionContent(location.href);
        }
      }.bind(this));
  
      this.init();
      this.pageLoaded = true;

      checkActiveColorTag();
    }
  
    Collection.prototype = $.extend({}, Collection.prototype, {
      init: function() {
        // init is called on load and when tags are selected
        this.$container = $(this.container);
        this.sectionId = this.$container.attr('data-section-id');
  
        this.sortBy();
        this.sortTags();
        this.initTagAjax();

        window.util.datatoggle.init();

        // on initial load, set the filters into hidden state 
        if (!this.pageLoaded) {
          $(classes.filterWrapperTrigger).removeClass('open');
          $(classes.filterWrapper).hide();
        }

        // add 300ms delay before adding the transition effects to prevent 
        // animation twitching on initial load and when an ajax call is done
        setTimeout(function(){
          $(classes.filterWrapperTrigger).addClass('enable-transitions');
        }, 100)
      },

      toggleClearFilter: function(){
        if ($(classes.tags).find('.' + classes.activeTag).length > 0) {
          $(classes.clearfilterID).show();
        }
      },
  
      initTagAjax: function() {
        var me = this;
        this.$container.on('click' + this.namespace, '.tags a', function(evt) {
          evt.preventDefault();
          var $el = $(evt.currentTarget);
          var newUrl = $el.attr('href');
          if ($el.hasClass(classes.taggedFilterClear)){
            // $(classes.tags).find('.' + classes.activeTag).removeClass(classes.activeTag);
          }
          else if ($el.hasClass(classes.taggedFilter)){
            // only clear the nearest same filter active tag
            // $el.closest('ul').find('.' + classes.activeTag).removeClass(classes.activeTag);
            // $el.parent().addClass(classes.activeTag);
          } else {
            $(classes.tags).find('.' + classes.activeTag).removeClass(classes.activeTag);
            $el.parent().addClass(classes.activeTag);
          }
          history.pushState({}, '', newUrl);
          $('.grid-product').addClass('unload');
          this.getNewCollectionContent(newUrl);
          me.toggleClearFilter();
        }.bind(this));
        me.toggleClearFilter();
      },
  
      getNewCollectionContent: function(url) {
        $('#CollectionAjaxResult').load(url + ' #CollectionAjaxContent', function() {
          this.reInit();
        }.bind(this));
      },
  
      sortBy: function() {
        var $sortBy = $('#SortBy');
  
        if (!$sortBy.length) {
          return;
        }
        $sortBy.on('change', function() {
            ocation.href = location.search + '?sort_by=' + $(this).val();
        });
      },
  
      sortTags: function() {
        var $sortTags = $('#SortTags');
  
        if (!$sortTags.length) {
          return;
        }
  
        $sortTags.on('change', function() {
          location.href = $(this).val();
        });
      },
    
      reInit: function() {
        // Reload collection template (it can be anywhere in the sections.instance array)
        for (var i = 0; i < sections.instances.length; i++) {
          var instance = sections.instances[i];
          if (instance['type'] === 'collection-template') {
            instance.forceReload();
          }
        }
  
        // Reload quick shop buttons
        theme.initQuickShop();
  
        // Reload products inside each quick shop
        sections.register('product-template', theme.Product);
        window.util.datatoggle.init();

        // Reinitialise slick slider
        if ($(window).width() < 590 ) {
          $('.slick-container').slick(args_mobile);
        }
        else {
          $('.slick-container').slick(args_desktop);
        }

        // initialise swatches
        agswatchcollection();

        // select active color filter (when not activated during collection rendering)
        checkActiveColorTag();
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        $(window).off(this.namespace);
        this.$container.off(this.namespace);
      }
  
    });
  
    return Collection;
  })();
theme.HeaderSection = (function() {

    var selectors = {
      drawer: '#NavDrawer',
      mobileSubNavToggle: '.mobile-nav__toggle-btn',
      hasSublist: '.mobile-nav__has-sublist'
    };
  
    var classes = {
      navExpanded: 'mobile-nav--expanded'
    };
  
    function Header(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
  
      // Reload any slideshow if when the header is reloaded to make sure the
      // sticky header works as expected (it can be anywhere in the sections.instance array)
      for (var i = 0; i < sections.instances.length; i++) {
        var instance = sections.instances[i];
        if (instance['type'] === 'slideshow-section') {
          instance.forceReload();
        }
      }
  
      //theme.currencySwitcher.init()
      this.initDrawers();
      theme.headerNav.init();
      theme.announcementBar.init();
    }
  
    Header.prototype = $.extend({}, Header.prototype, {
      initDrawers: function() {
        theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
        if (theme.settings.cartType === 'drawer') {
          new theme.CartDrawer();
        }
  
        this.drawerMenuButtons();
      },
  
      drawerMenuButtons: function() {
        $(selectors.drawer).find('.js-drawer-close').on('click', function(evt){
          evt.preventDefault();
          theme.NavDrawer.close();
        });
  
        var $mobileSubNavToggle = $(selectors.mobileSubNavToggle);
  
        $mobileSubNavToggle.attr('aria-expanded', 'false');
        $mobileSubNavToggle.each(function (i, el) {
          var $el = $(el);
          $el.attr('aria-controls', $el.attr('data-aria-controls'));
        });
  
        $mobileSubNavToggle.on('click', function() {
          var $el = $(this);
          var currentlyExpanded = $el.attr('aria-expanded');
          var toggleState = false;
  
          // Updated aria-expanded value based on state pre-click
          if (currentlyExpanded === 'true') {
            $el.attr('aria-expanded', 'false');
          } else {
            $el.attr('aria-expanded', 'true');
            toggleState = true;
          }
  
          // Toggle class that expands/collapses sublist
          $el.closest(selectors.hasSublist).toggleClass(classes.navExpanded, toggleState);
        });
      },
  
      onUnload: function() {
        theme.NavDrawer.close();
        theme.headerNav.unload();
      }
    });
  
    return Header;
  
  })();
theme.FeaturedContentSection = (function() {

    function FeaturedContent() {
      $('.rte').find('a:not(:has(img))').addClass('text-link');
    }
  
    return FeaturedContent;
  })();
theme.slideshows = {};

theme.SlideshowSection = (function() {

    function SlideshowSection(container) {
        var $container = this.$container = $(container);
        var $section = $container.parent();
        var sectionId = $container.attr('data-section-id');
        var slideshow = this.slideshow = '#Slideshow-' + sectionId;

        var $imageContainer = $(container).find('.hero');
        if ($imageContainer.length) {
        theme.loadImageSection($imageContainer);
        }

        this.init();
    }

    SlideshowSection.prototype = $.extend({}, SlideshowSection.prototype, {
        init: function() {
        var args = {
            arrows: $(this.slideshow).data('arrows'),
            dots: $(this.slideshow).data('dots')
        };

        theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow, args);
        },

        forceReload: function() {
        this.onUnload();
        this.init();
        },

        onUnload: function() {
        theme.slideshows[this.slideshow].destroy();
        delete theme.slideshows[this.slideshow];
        },

        onSelect: function() {
        $(this.slideshow).slick('slickPause');
        },

        onDeselect: function() {
        $(this.slideshow).slick('slickPlay');
        },

        onBlockSelect: function(evt) {
        var $slideshow = $(this.slideshow);

        // Ignore the cloned version
        var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');

        // Go to selected slide, pause autoplay
        $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
        },

        onBlockDeselect: function() {
        $(this.slideshow).slick('slickPlay');
        }
    });

    return SlideshowSection;
})();
theme.VideoSection = (function() {
    var youtubeReady;
    var videos = [];
    var youtubePlayers = [];
    var youtubeVideoOptions = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        branding: 0,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      },
      events: {
        onReady: onVideoPlayerReady,
        onStateChange: onVideoStateChange
      }
    };
  
    var vimeoReady = false;
    var vimeoVideoOptions = {
      byline: false,
      title: false,
      portrait: false,
      loop: true
    };
  
    var selectors = {
      videoParent: '.video-parent-section'
    };
  
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    };
  
    function videoSection(container) {
      if (theme.config.isIframe) {
        return;
      }
  
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
      var youtubePlayerId = this.youtubePlayerId = 'YouTubeVideo-' + this.sectionId;
      this.namespace = '.' + youtubePlayerId;
      var vimeoPlayerId = this.vimeoPlayerId = 'Vimeo-' + this.sectionId;
      var $vimeoTrigger = this.$vimeoTrigger = $('#VimeoTrigger-' + this.sectionId);
      var mp4Video = 'Mp4Video-' + this.sectionId;
  
      var $youtubeDiv = $('#' + youtubePlayerId);
      var $vimeoDiv = $('#' + vimeoPlayerId);
      var $mp4Div = $('#' + mp4Video);
  
      this.vimeoPlayer = [];
  
      if ($youtubeDiv.length) {
        this.youtubeVideoId = $youtubeDiv.data('video-id');
        this.initYoutubeVideo();
      }
  
      if ($vimeoDiv.length) {
        this.vimeoVideoId = $vimeoDiv.data('video-id');
        this.initVimeoVideo();
      }
  
      if ($mp4Div.length) {
        setParentAsLoaded($mp4Div);
  
        startMp4Playback(mp4Video).then(function() {
          // Video played as expected, don't do anything
        }).catch(function(error) {
          // Video cannot be played with autoplay, so let
          // user interact with video element itself
          setVideoToBeInteractedWith($mp4Div);
        })
      }
    }
  
    function startMp4Playback(mp4Video) {
      return document.querySelector('#' + mp4Video).play();
    }
  
    function onVideoPlayerReady(evt) {
      var $player = $(evt.target.a);
      var playerId = $player.attr('id');
      youtubePlayers[playerId] = evt.target; // update stored player
      var player = youtubePlayers[playerId];
  
      setParentAsLoading($player);
  
      youtubePlayers[playerId].mute();
  
      // Remove from tabindex because YouTube iframes are annoying and you can focus
      // on the YouTube logo and it breaks
      $player.attr('tabindex', '-1');
  
      // Add out of view pausing
      videoVisibilityCheck(playerId);
      $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
    }
  
    function videoVisibilityCheck(id) {
      var playerId;
  
      if (typeof id === 'string') {
        playerId = id;
      } else {
        // Data comes in as part of the scroll event
        if (id) {
          playerId = id.data.id;
        } else {
          playerId = document.querySelector('[data-section-type="video-section"] [data-video-id]').id;
        }
      }
  
      if (theme.isElementVisible($('#' + playerId))) {
        playVisibleVideo(playerId);
      } else {
        pauseHiddenVideo(playerId);
      }
    }
  
    function playVisibleVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
        youtubePlayers[id].playVideo();
      }
    }
  
    function pauseHiddenVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
        youtubePlayers[id].pauseVideo();
      }
    }
  
    function onVideoStateChange(evt) {
      var $player = $(evt.target.a);
      var playerId = $player.attr('id');
      var player = youtubePlayers[playerId];
  
      switch (evt.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (videos[playerId] && videos[playerId].attemptedToPlay) {
            setParentAsLoaded($player);
            setVideoToBeInteractedWith($player);
          }
          break;
        case 0: // ended
          player.playVideo();
          break;
        case 1: // playing
          setParentAsLoaded($player);
          break;
        case 3: // buffering
          if (videos[playerId]) {
            videos[playerId].attemptedToPlay = true;
          }
          break;
      }
    }
  
    function setParentAsLoading($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.loading);
    }
  
    function setParentAsLoaded($el) {
      $el
        .closest(selectors.videoParent)
        .removeClass(classes.loading)
        .addClass(classes.loaded);
    }
  
    function setVideoToBeInteractedWith($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.interactable);
    }
  
    videoSection.prototype = $.extend({}, videoSection.prototype, {
      initYoutubeVideo: function() {
        videos[this.youtubePlayerId] = {
          id: this.youtubePlayerId,
          videoId: this.youtubeVideoId,
          type: 'youtube',
          attemptedToPlay: false
        };
  
        if (!youtubeReady) {
          window.loadYouTube();
          $('body').on('youTubeReady' + this.namespace, this.loadYoutubeVideo.bind(this));
        } else {
          this.loadYoutubeVideo();
        }
      },
  
      loadYoutubeVideo: function() {
        var args = $.extend({}, youtubeVideoOptions, videos[this.youtubePlayerId]);
        args.playerVars.controls = 0;
        youtubePlayers[this.youtubePlayerId] = new YT.Player(this.youtubePlayerId, args);    

        const playerId = youtubePlayers[this.youtubePlayerId].v.id
        const playerElement = document.getElementById(playerId)
        playerElement.src = `${ playerElement.src }&autoplay=1&loop=1` 
        playerElement.classList.add('sample-class')
        setTimeout(function() {
          playerElement.src += ''
          console.log('reloaded');
        }, 1000)
        
        youtubeReady = true;
      },
  
      initVimeoVideo: function() {
        videos[this.vimeoPlayerId] = {
          divId: this.vimeoPlayerId,
          id: this.vimeoVideoId,
          type: 'vimeo'
        };
  
        var $player = $('#' + this.vimeoPlayerId);
        setParentAsLoading($player);
  
        // Button to play video on mobile
        this.$vimeoTrigger.on('click', + this.namespace, function(evt) {
          // $(evt.currentTarget).addClass('hide');
          this.requestToPlayVimeoVideo(this.vimeoPlayerId);
        }.bind(this));
  
        if (!vimeoReady) {
          window.loadVimeo();
          $('body').on('vimeoReady' + this.namespace, this.loadVimeoVideo.bind(this));
        } else {
          this.loadVimeoVideo();
        }
      },
  
      loadVimeoVideo: function() {
        var args = $.extend({}, vimeoVideoOptions, videos[this.vimeoPlayerId]);
        this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(videos[this.vimeoPlayerId].divId, args);
  
        vimeoReady = true;
  
        // Only autoplay on larger screens
        if (!theme.config.bpSmall) {
          this.requestToPlayVimeoVideo(this.vimeoPlayerId);
        } else {
          var $player = $('#' + this.vimeoPlayerId);
          setParentAsLoaded($player);
        }
      },
  
      requestToPlayVimeoVideo: function(id) {
        // The slider may initialize and attempt to play the video before
        // the API is even ready, because it sucks.
  
        if (!vimeoReady) {
          // Wait for the trigger, then play it
          $('body').on('vimeoReady' + this.namespace, function() {
            this.playVimeoVideo(id);
          }.bind(this))
          return;
        }
  
        this.playVimeoVideo(id);
      },
  
      playVimeoVideo: function(id) {
        this.vimeoPlayer[id].play();
        this.vimeoPlayer[id].setVolume(0);
  
        var $player = $('#' + id);
        setParentAsLoaded($player);
      },
  
      onUnload: function(evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '');
        var playerId = 'YouTubeVideo-' + sectionId;
        youtubePlayers[playerId].destroy();
        $(window).off('scroll' + this.namespace);
        $('body').off('vimeoReady' + this.namespace);
      }
    });
  
    return videoSection;
  })();
theme.Testimonials = (function() {
    var slideCount = 0;
    var defaults = {
      accessibility: true,
      arrows: false,
      dots: true,
      autoplay: false,
      touchThreshold: 20,
      slidesToShow: 3,
      slidesToScroll: 3
    };
  
    function Testimonials(container) {
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      var wrapper = this.wrapper = '.testimonials-wrapper';
      var slider = this.slider = '#Testimonials-' + sectionId;
      var $slider = $(slider);
  
      this.sliderActive = false;
      var mobileOptions = $.extend({}, defaults, {
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true
      });
  
      slideCount = $slider.data('count');
  
      // Override slidesToShow/Scroll if there are not enough blocks
      if (slideCount < defaults.slidesToShow) {
        defaults.slidesToShow = slideCount;
        defaults.slidesToScroll = slideCount;
      }
  
      $slider.on('init', this.a11y.bind(this));
  
      if (theme.config.bpSmall) {
        this.init($slider, mobileOptions);
      } else {
        this.init($slider, defaults);
      }
  
      $('body').on('matchSmall', function() {
        this.init($slider, mobileOptions);
      }.bind(this));
  
      $('body').on('matchLarge', function() {
        this.init($slider, defaults);
      }.bind(this));
    }
  
    Testimonials.prototype = $.extend({}, Testimonials.prototype, {
      onUnload: function() {
        $(this.slider, this.wrapper).slick('unslick');
      },
  
      onBlockSelect: function(evt) {
        // Ignore the cloned version
        var $slide = $('.testimonials-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');
  
        // Go to selected slide, pause autoplay
        $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
      },
  
      init: function(obj, args) {
        if (this.sliderActive) {
          obj.slick('unslick');
          this.sliderActive = false;
        }
  
        obj.slick(args);
        this.sliderActive = true;
      },
  
      a11y: function(event, obj) {
        var $list = obj.$list;
        var $wrapper = $(this.wrapper, this.$container);
  
        // Remove default Slick aria-live attr until slider is focused
        $list.removeAttr('aria-live');
  
        // When an element in the slider is focused set aria-live
        $wrapper.on('focusin', function(evt) {
          if ($wrapper.has(evt.target).length) {
            $list.attr('aria-live', 'polite');
          }
        });
  
        // Remove aria-live
        $wrapper.on('focusout', function(evt) {
          if ($wrapper.has(evt.target).length) {
            $list.removeAttr('aria-live');
          }
        });
      }
    });
  
    return Testimonials;
  })();
theme.Instagram = (function() {
    var defaults = {
  
    };
  
    function Instagram(container) {
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      var $target = $('#Instafeed-' + sectionId);
  
      if (!$target.length) {
        return;
      }
  
      var userId = $target.data('user-id');
      var clientId = $target.data('client-id');
      var count = $target.data('count');
  
      var feed = this.feed = new Instafeed({
        target: $target[0],
        accessToken: clientId,
        get: 'user',
        userId: userId,
        limit: count,
        template: '<div class="grid__item small--one-half medium-up--one-fifth" data-aos="row-of-5"><div class="image-wrap"><a href="{% raw %}{{link}}{% endraw %}" target="_blank" style="background-image: url({% raw %}{{image}}{% endraw %}); display: block; padding-bottom: 100%; background-size: cover;"></a></div></div>',
        resolution: 'standard_resolution'
      });
  
      feed.run();
    }
  
    Instagram.prototype = $.extend({}, Instagram.prototype, {
      onUnload: function() {
  
      }
    });
  
    return Instagram;
  })();
theme.NewsletterPopup = (function() {
    function NewsletterPopup(container) {
        var $container = this.$container = $(container);
        var sectionId = $container.attr('data-section-id');
        this.cookieName = 'newsletter-' + sectionId;
    
        if (!$container.length) {
            return;
        }
    
        this.data = {
            secondsBeforeShow: $container.data('delay-seconds'),
            daysBeforeReappear: $container.data('delay-days'),
            cookie: $.cookie(this.cookieName),
            testMode: $container.data('test-mode')
        };
    
        this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');
    
        // Open modal if errors or success message exist
        if ($container.find('.errors').length || $container.find('.note--success').length) {
            this.modal.open();
        }
    
        // Set cookie as opened if success message
        if ($container.find('.note--success').length) {
            this.closePopup();
            return;
        }
    
        $('body').on('modalClose.' + $container.attr('id'), this.closePopup.bind(this));
    
        if (!this.data.cookie || this.data.testMode) {
            this.initPopupDelay();
        }
        }
    
        NewsletterPopup.prototype = $.extend({}, NewsletterPopup.prototype, {
        initPopupDelay: function() {
            setTimeout(function() {
            this.modal.open();
            }.bind(this), this.data.secondsBeforeShow * 1000);
        },
    
        closePopup: function() {
            // Remove a cookie in case it was set in test mode
            if (this.data.testMode) {
            $.removeCookie(this.cookieName, { path: '/' });
            return;
            }
    
            $.cookie(this.cookieName, 'opened', { expires: this.data.daysBeforeReappear });
        },
    
        onLoad: function() {
            this.modal.open();
        },
    
        onSelect: function() {
            this.modal.open();
        },
    
        onDeselect: function() {
            this.modal.close();
        },
    
        onUnload: function() {}
    });
    
    return NewsletterPopup;
})();
theme.FadingImages = (function() {

    var classes = {
      activeImage: 'active-image',
      finishedImage: 'finished-image',
      activeTitles: 'active-titles',
      finishedTitles: 'finished-titles',
      compensation: 'compensation'
    };
  
    function FadingImages(container) {
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      var namespace = this.namespace = '.fading-images-' + sectionId;
  
      if (!$container.length) {
        return;
      }
  
      var $imageContainer = $container.find('.fading-images');
      theme.loadImageSection($imageContainer);
  
      this.data = {
        isInit: false,
        interval: $container.data('interval'),
        block_count: $container.data('count'),
        finish_interval: 1000,
        timer_offset: 400,
        active_image: 1,
        active_title: 1,
        removed_compensation: false
      };
  
      this.selectors = {
        $allTitles: $container.find('.fading-images-overlay__titles')
      };
  
      this.checkVisibility();
      $(window).on('scroll' + this.namespace, $.throttle(100, this.checkVisibility.bind(this)));
    }
  
    FadingImages.prototype = $.extend({}, FadingImages.prototype, {
      checkVisibility: function() {
        if (this.data.isInit) {
          $(window).off('scroll' + this.namespace);
          return;
        }
  
        if (theme.isElementVisible(this.$container)) {
          this.startImages();
          this.startTitles();
          this.data.isInit = true;
        }
      },
  
      nextImage: function() {
        var $container = this.$container;
  
        if (!this.data.removed_compensation) {
          $container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').removeClass(classes.compensation);
          this.data.removed_compensation = true;
        }
  
        $container
          .find('.fading-images__item[data-slide-index=' + this.data.active_image + ']')
          .removeClass(classes.activeImage)
          .addClass(classes.finishedImage);
  
        var target_image = this.data.active_image;
        window.setTimeout(function() {
          $container.find('.fading-images__item[data-slide-index=' + target_image + ']').removeClass(classes.finishedImage);
        }, this.data.finish_interval);
  
        this.data.active_image++;
        if (this.data.active_image > this.data.block_count) {
          this.data.active_image = 1;
        }
  
        $container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').addClass(classes.activeImage);
      },
  
      nextTitle: function() {
        var $container = this.$container;
        var $allTitles = this.selectors.$allTitles;
  
        this.selectors.$allTitles.removeClass(classes.activeTitles).addClass(classes.finishedTitles);
  
        this.data.active_title++;
        if (this.data.active_title > this.data.block_count) {
          this.data.active_title = 1;
        }
  
        var target_title = this.data.active_title;
        window.setTimeout(function() {
          var newText1 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title1');
          var newText2 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title2');
          $container.find('.fading-images-overlay__title--1').text(newText1);
          $container.find('.fading-images-overlay__title--2').text(newText2);
          $allTitles.removeClass(classes.finishedTitles).addClass(classes.activeTitles);
        }, this.data.finish_interval - 200);
      },
  
      startImages: function() {
        // Prep and show first image
        this.$container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').addClass(classes.activeImage).addClass(classes.compensation);
  
        // Begin timer
        var o = this;
        window.setTimeout(function() {
          var fading_images_timer = window.setInterval(o.nextImage.bind(o), o.data.interval);
        }, this.data.timer_offset);
      },
  
      startTitles: function() {
        var $container = this.$container;
        var $allTitles = this.selectors.$allTitles;
        // Prep and show first titles
        var target_title = this.data.active_title;
        window.setTimeout(function() {
          var newText1 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title1');
          var newText2 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title2');
          $container.find('.fading-images-overlay__title--1').text(newText1);
          $container.find('.fading-images-overlay__title--2').text(newText2);
          $allTitles.addClass(classes.activeTitles);
        }, 350);
  
        // Begin timer
        var fading_titles_timer = window.setInterval(this.nextTitle.bind(this), this.data.interval);
      },
  
      onLoad: function() {
      },
  
      onSelect: function() {
      },
  
      onDeselect: function() {
      },
  
      onUnload: function() {
      }
    });
  
    return FadingImages;
  })();
theme.Maps = (function() {
    var config = {
      zoom: 14
    };
    var apiStatus = null;
    var mapsToLoad = [];
  
    var errors = {
      addressNoResults: theme.strings.addressNoResults,
      addressQueryLimit: theme.strings.addressQueryLimit,
      addressError: theme.strings.addressError,
      authError: theme.strings.authError
    };
  
    var selectors = {
      section: '[data-section-type="map"]',
      map: '[data-map]',
      mapOverlay: '[data-map-overlay]'
    };
  
    var classes = {
      mapError: 'map-section--load-error',
      errorMsg: 'map-section__error errors text-center'
    };
  
    // Global function called by Google on auth errors.
    // Show an auto error message on all map instances.
    window.gm_authFailure = function() {
      if (!Shopify.designMode) {
        return;
      }
  
      $(selectors.section).addClass(classes.mapError);
      $(selectors.map).remove();
      $(selectors.mapOverlay).after(
        '<div class="' +
          classes.errorMsg +
          '">' +
          theme.strings.authError +
          '</div>'
      );
    };
  
    function Map(container) {
      this.$container = $(container);
      this.sectionId = this.$container.attr('data-section-id');
      this.namespace = '.map-' + this.sectionId;
      this.$map = this.$container.find(selectors.map);
      this.key = this.$map.data('api-key');
  
      if (!this.key) {
        return;
      }
  
      // Lazyload API
      this.checkVisibility();
      $(window).on('scroll' + this.namespace, $.throttle(50, this.checkVisibility.bind(this)));
    }
  
    function initAllMaps() {
      // API has loaded, load all Map instances in queue
      $.each(mapsToLoad, function(index, instance) {
        instance.createMap();
      });
    }
  
    function geolocate($map) {
      var deferred = $.Deferred();
      var geocoder = new google.maps.Geocoder();
      var address = $map.data('address-setting');
  
      geocoder.geocode({ address: address }, function(results, status) {
        if (status !== google.maps.GeocoderStatus.OK) {
          deferred.reject(status);
        }
  
        deferred.resolve(results);
      });
  
      return deferred;
    }
  
    Map.prototype = $.extend({}, Map.prototype, {
      prepMapApi: function() {
        if (apiStatus === 'loaded') {
          this.createMap();
        } else {
          mapsToLoad.push(this);
  
          if (apiStatus !== 'loading') {
            apiStatus = 'loading';
            if (typeof window.google === 'undefined') {
              $.getScript(
                'https://maps.googleapis.com/maps/api/js?key=' + this.key
              ).then(function() {
                apiStatus = 'loaded';
                initAllMaps();
              });
            }
          }
        }
      },
  
      createMap: function() {
        var $map = this.$map;
        return geolocate($map)
          .then(
            function(results) {
              var mapOptions = {
                zoom: config.zoom,
                backgroundColor: 'none',
                center: results[0].geometry.location,
                draggable: false,
                clickableIcons: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: true,
                styles: $map.data('styles')
              };
  
              var map = (this.map = new google.maps.Map($map[0], mapOptions));
              var center = (this.center = map.getCenter());
  
              var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter()
              });
  
              google.maps.event.addDomListener(
                window,
                'resize',
                $.debounce(250, function() {
                  google.maps.event.trigger(map, 'resize');
                  map.setCenter(center);
                  $map.removeAttr('style');
                })
              );
            }.bind(this)
          )
          .fail(function() {
            var errorMessage;
  
            switch (status) {
              case 'ZERO_RESULTS':
                errorMessage = errors.addressNoResults;
                break;
              case 'OVER_QUERY_LIMIT':
                errorMessage = errors.addressQueryLimit;
                break;
              case 'REQUEST_DENIED':
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }
  
            // Show errors only to merchant in the editor.
            if (Shopify.designMode) {
              $map
                .parent()
                .addClass(classes.mapError)
                .html(
                  '<div class="' +
                    classes.errorMsg +
                    '">' +
                    errorMessage +
                    '</div>'
                );
            }
          });
      },
  
      checkVisibility: function() {
        if (theme.isElementVisible(this.$container, 600)) {
          this.prepMapApi();
          $(window).off(this.namespace);
        }
      },
  
      onUnload: function() {
        if (this.$map.length === 0) {
          return;
        }
        // Causes a harmless JS error when a section without an active map is reloaded
        google.maps.event.clearListeners(this.map, 'resize');
      }
    });
  
    return Map;
  })();

theme.Blog = (function() {

    function Blog(container) {
      this.tagFilters();
    }
  
    Blog.prototype = $.extend({}, Blog.prototype, {
      tagFilters: function() {
        var $filterBy = $('#BlogTagFilter');
  
        if (!$filterBy.length) {
          return;
        }
  
        $filterBy.on('change', function() {
          location.href = $(this).val();
        });
      },
  
      onUnload: function() {
  
      }
    });
  
    return Blog;
  })();
theme.Photoswipe = (function() {
    var selectors = {
      photoswipeImg: '.photoswipe__image'
    }
  
    function Photoswipe(container) {
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      this.namespace = '.photoswipe-' + this.sectionId;
      var $images = this.$images = $container.find(selectors.photoswipeImg);
      this.gallery;
  
      if (!$container.length) {
        return;
      }
  
      this.init();
    }
  
    Photoswipe.prototype = $.extend({}, Photoswipe.prototype, {
      init: function() {
        var haveImages = false;
        var items = [];
        var options = {};
  
        this.$images.each(function() {
          var haveImages = true;
          var smallSrc = $(this).prop('currentSrc') || $(this).prop('src');
          var item = {
            msrc: smallSrc,
            src: $(this).data('photoswipe-src'),
            w: $(this).data('photoswipe-width'),
            h: $(this).data('photoswipe-height'),
            el: $(this)[0]
          };
  
          items.push(item);
        });
  
        this.$images.on('click' + this.namespace, function(evt) {
          index = $(evt.currentTarget).data('index');
          this.initGallery(items, index);
        }.bind(this));
      },
  
      initGallery: function(items, index) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
  
        var options = {
          history: false,
          index: index - 1,
          getThumbBoundsFn: function(index) {
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
          }
        }
  
        this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        this.gallery.init();
      },
  
      onUnload: function() {
        this.$images.off('click' + this.namespace);
        this.gallery.destroy()
      }
    });
  
    return Photoswipe;
  })();
//Footer Newsletter
$(window).on('load', function(){
  if ($("#customer-newsletter-form .errors").length > 0 || $("#customer-newsletter-form .newsletter__form-message").length > 0) {
    $('html, body').animate({
      scrollTop: $("#customer-newsletter-form").offset().top
    }, 0);
  }
});
$(document).ready(function() {
    if ($("body").hasClass('template-cart')){
      if (theme.settings.shippingCalculator != "Disabled"){
        Shopify.Cart.ShippingCalculator.show( {
          submitButton: theme.strings.shippingCalcSubmitButton,
          submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
          customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
          moneyFormat: theme.strings.shippingCalcMoneyFormat                                     
        } );
      }
    }
});
// module needs to be called after product.js as this extends the init method
// and adds recently viewed functionality
if ($("body").hasClass("template-product") && $("[data-recently-viewed-section]").length >= 0){
    var cookie_placeholder = "recently_viewed_pdp";
    var cookie_lifespan = 90;
    var cookie_product_limit = 100;
    var wrapper_selector = "[data-recently-viewed-section]";
    var template = $("#RecentlyViewedTemplate").html();
    var image_size = "x1000";


    $.extend(theme.Product.prototype, {
        originalInit: theme.Product.prototype.init,
        init: function(){
            this.originalInit();
            
            // record product in recently veiwed 
            if (!this.inModal){ // only needed when modal/quickview is supported

              var $el = $(wrapper_selector);

              this.recordProduct(this.productObject.handle);
              
              this.showRecentlyViewed(this.productObject.handle).then(function(data) {

                data.forEach(function(data) {
                  $el.append(Handlebars.compile(template)(data));
                })

                $el.show()
                if(data.length === 1) {
                  $el.addClass('recently-viewed__resize')
                } else {
                  $el.addClass('recently-viewed__center')
                  $el.slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    arrows: false,
                    responsive: [
                      {
                        breakpoint: 767,
                        settings: {
                          infinite: false,
                          slidesToShow: 1.9
                        }
                      }
                    ]
                  })
                }
              });
            }

        },
        recordProduct : function(product_handle){
            var recentlyViewedProducts = util.getCookie(cookie_placeholder);
            if (!recentlyViewedProducts){
                recentlyViewedProducts = [];
                $('li[data-tab=recently-viewed]').hide();
            } else {
                recentlyViewedProducts = recentlyViewedProducts.split(",");
                $('li[data-tab=recently-viewed]').show();
            }
    
            // check if already existing and remove previous handle from cookie
            if (recentlyViewedProducts.indexOf(product_handle) >= 0){
                var index = recentlyViewedProducts.indexOf(product_handle);
                recentlyViewedProducts.splice(index, 1);
            };
    
            // limit displayed products +1 as self can be selected
            var cookie_limit = (cookie_product_limit + 1);
            if (recentlyViewedProducts.length > cookie_limit) {
                recentlyViewedProducts = recentlyViewedProducts.slice(0, cookie_limit);
            }
            
            recentlyViewedProducts.push(product_handle);
            util.setCookie(cookie_placeholder, recentlyViewedProducts,cookie_lifespan)
        },
        resizeImage: function(src, size) {
            if (size == null) {
                return src;
            }
            if (size == 'master') {
                return src.replace(/http(s)?:/, "");
            }
            var match  = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
            if (match != null) {
                var prefix = src.split(match[0]);
                var suffix = match[0];
                return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
            } else {
                return null;
            }
        },
        showRecentlyViewed: function(current_handle) {
          var me = this;
          if (util.getCookie(cookie_placeholder) != null) {
            var product_handles = util.getCookie(cookie_placeholder).split(",").filter(function(handle) {
              return handle !== current_handle
            });

            return Promise.all(product_handles.reverse().slice(0, 4).map(function(handle) {
              return me.fetchProduct(handle)
            }))
          }
        },
        fetchProduct(handle) {
          return new Promise(function(resolve) {
            $.getJSON("/products/" + handle + ".js", function(data){
                      
              var sale_price = theme.Currency.formatMoney(data.compare_at_price)
              
              data = {
                url: data.url,
                featured_image : data.media[0].src,
                featured_image_aspect_ratio : (100 / data.media[0].aspect_ratio),
                featured_image_alt : data.media[0].alt,
                price : theme.Currency.formatMoney(data.price),
                compare_at_price : theme.Currency.formatMoney(data.compare_at_price),
                title : data.title,
                src: data.media?.[1]?.src || data.media?.[0]?.src || "",
                aspect_ratio: data.media?.[1]?.aspect_ratio ? (100 / data.media[1].aspect_ratio) : (data.media?.[0]?.aspect_ratio ? (100 / data.media[0].aspect_ratio) : 100),
                alt: data.media?.[1]?.alt || data.media?.[0]?.alt || "",
                sale: data.compare_at_price_max > data.price_max ? sale_price : ''
              }
              
              resolve(data)
            });
          })
        }
    });
}

if ($("body").hasClass("template-product") && $("[data-pdp-swatch-wrapper]").length >= 0){
    var $el = $("[data-swatch-color-display]");
    $("[data-swatch-color-hover]").on("mouseenter", function(){
        $el.text($(this).attr('title'));
    });
    $("[data-swatch-color-hover]").on("mouseleave", function(){
        $el.text($el.data('default-text'));
    });

    $("a[data-swatch-variants]").on('click', function(e){
        e.preventDefault();
        var selected_swatch = $(this);
        if (selected_swatch.hasClass('active')){
            return false;
        } else {
            // get selected option
            // THIS ASSUMES THAT THERE IS ONLY ONE OPTION FOR THIS PRODUCT
            var selectedOption = [];
            $(".variant-wrapper .variant-input-wrap").each(function(){
                var key = $(this).attr('name');
                if (key){
                    selectedOption.push($("input[name='"+key+"']:checked").val());
                }
            });

            var swatch_variants = selected_swatch.data("swatch-variants");
            $('body').addClass('unloading');
            var src = $(this).attr('href');
            var src_append = "";
            for (var key in swatch_variants){
                var swatch_variant = swatch_variants[key];
                if (swatch_variant.title == selectedOption.join(" / ")){
                    src_append = "?variant=" + swatch_variant.id;
                    break;
                }
            }

            window.setTimeout(function() {
                location.href = src + src_append;
            }, 10);
        }
    });
}

if ($("body").hasClass("template-index") && $("[data-grid-swatch-wrapper]").length >= 0){
    agswatchcollection();
}

if ($("body").hasClass("template-collection") && $("[data-grid-swatch-wrapper]").length >= 0){
    agswatchcollection();
}

if ($("body").hasClass("template-product") && $("[data-grid-swatch-wrapper]").length >= 0){
    agswatchcollection();
}

if ($("body").hasClass("template-search") && $("[data-grid-swatch-wrapper]").length >= 0){
    agswatchcollection();
}

if ($("body").hasClass("template-collection") && $("[data-grid-swatch-wrapper]").length >= 0){

  window.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
      const swatchParents = $(".ag-swatch-collection");
      swatchParents.each((index, swatch) => {
        handleSwatchClick(swatch);
        getActiveSwatch(swatch);
      })
    }, 6000)
  })

  window.addEventListener("resize", function() { 
    setTimeout(() => {
      const swatchParents = $(".ag-swatch-collection");
      swatchParents.each((index, swatch) => {
        handleSwatchClick(swatch);
        getActiveSwatch(swatch);
      })
    }, 6000)
  })

  let currPage = location.href;
  setInterval(function() {
      if (currPage != location.href){
        setTimeout(() => {
          const swatchParents = $(".ag-swatch-collection");
          swatchParents.each((index, swatch) => {
            handleSwatchClick(swatch);
            getActiveSwatch(swatch);
          })
        }, 4000)
          currPage = location.href;
      }
  }, 500);
}


function agswatchcollection() {
  if ($(".ag-swatch-collection").length >= 0) {
      $.each($(".ag-swatch-collection"), function( index, value ) {
          var $el = $(this);
          if (!$.contains( $el, $('a'))) {
              doSwatchAjax($el); 
          }
      });
  }
}

// activate active color filter (when collection failed rendering the active tag)
function checkActiveColorTag() {
  var path = $('#urlPath').val();
  $('ul.tags--color li').each(function() {
    var color = $(this).attr('data-color');
    if (path.indexOf(color) != -1) {
      if (!$(this).hasClass('collection-sidebar__item--active tag--active')) {
        $(this).addClass('collection-sidebar__item--active tag--active');
        var color_value = color.split('-');
        var color_string = color_value[1];
        if (color_string) {
          $(this).find('a').attr('title', 'Remove tag Color:' + color_string.toUpperCase()); 
        }
      }
      
    }
  });
}

$('body').on('click', 'a[data-swatch-variants]', function(e){
    e.preventDefault();
    var $el = $(this);
    var $gridItem = $el.closest(".grid__item.grid-product");
    if ($gridItem.length === 0) { return; }

    $el.closest('.variant-wrapper--swatches').find('.swatch').removeClass('active');
    $el.addClass('active');
    
    var productdata = $el.data('product');
    //console.log(productdata);
    // update images
    var images = $el.data('images'); 
    if (typeof images === 'string') {
      try {
        images = JSON.parse(images);
      } catch(e) {
        images = [];
      }
    }
    
    if (($("body").hasClass("template-collection") || $("body").hasClass("template-search")) && $("[data-grid-swatch-wrapper]").length > 0){  
      if (Array.isArray(images) && images.length) {
        var $slider = $gridItem.find('.grid-slick-slider');
        if ($slider.length) {
            if ($slider.hasClass('slick-initialized')) {
              $slider.slick('unslick');
            }
            $slider.empty();

            images.forEach(function(imgUrl, index) {
              let slide = '';

              if (index === 0 && images.length > 1) {
                slide = `
                  <a href="${productdata.url}" class="grid-product__link grid_link_prm product-ez-image ratio-${theme.settings.ImageRatio}">
                    <img 
                      src="${images[0]}" 
                      class="grid-product__image" 
                      alt="" 
                      width="480" 
                      loading="lazy"
                    />
                    <img 
                      src="${images[1]}" 
                      class="grid-product__image grid-scr" 
                      alt="" 
                      width="480" 
                      loading="lazy"
                    />
                  </a>`;
              } else if (index !== 1) {
                slide = `
                  <a href="${productdata.url}" class="grid-product__link product-ez-image ratio-${theme.settings.ImageRatio}">
                    <img 
                      src="${imgUrl}" 
                      class="grid-product__image" 
                      alt="" 
                      width="480" 
                      loading="lazy"
                    />
                  </a>`;
              }

              if (slide) {
                $slider.append(slide);
              }
            });


            collectionImagesSlider($slider);
        }
      }

    }

    else{

      var $primaryImage = $gridItem.find(".grid-product__image");
      var $secondaryImage = $gridItem.find(".grid-product__secondary-image");
      var secondaryBgset = $el.data('secondary-bgset');
      var aspectRatio = $el.data('aspect-ratio');

      $primaryImage.attr('srcset', $el.data('primary-bgset'));
      $primaryImage.closest('.image-wrap').css("padding-bottom", aspectRatio +"%");
      $secondaryImage.find('picture').attr('srcset', secondaryBgset);
      $secondaryImage.find('source').attr('srcset', secondaryBgset);
      // if no bgset, remove current secondary image background on hover
      if (!secondaryBgset){
          $secondaryImage.css("background-image","");
      }
      $secondaryImage.css("background-image","");

    }

    // update title and link, price
    $gridItem.find(".grid-product__title").text(productdata.title);
    $gridItem.find(".grid-product__link").attr('href', productdata.url);
    $gridItem.find(".grid-ez-price").text(productdata.price);
    if(productdata.compare_at_price != '' ){
      $gridItem.find(".grid-product__price--original").text(productdata.compare_at_price);
      $gridItem.find(".grid-product__price--original").show();
    }
    else{
      $gridItem.find(".grid-product__price--original").hide();
    }

    if(productdata.discount_percent != ''){
      $gridItem.find(".grid-product__sale span").text(productdata.discount_percent);
      $gridItem.find(".grid-product__sale").show();
    }
    else{
      $gridItem.find(".grid-product__sale").hide();
    }

    var sizeVariants = $el.attr('data-size-variants');

    if(sizeVariants){
      try {
          var variants = JSON.parse(sizeVariants);
          var $sizeWrapper = $gridItem.find('.ezr_size_swatches_inn');

          if($sizeWrapper.length){
              $sizeWrapper.find('.ezr_size_swatch').remove();

              variants.forEach(function(variant, i){
                var activeClass = i === 0 ? 'active' : '';

                var sizeHtml = '';

                if(variant.available){
                  sizeHtml = `
                    <div class="ezr_size_swatch">
                      <a href="javascript:void(0);" class="ezr_add_to_cart_swatch ${activeClass}" data-id="${variant.id}">
                        ${variant.name}
                      </a>
                    </div>
                  `;
                } else {
                  sizeHtml = `
                    <div class="ezr_size_swatch">
                      <span>${variant.name}</span>
                    </div>
                  `;
                }

                $sizeWrapper.append(sizeHtml);
              });
          }
      } catch(e) {
          console.error("Invalid JSON in data-size-variants", e);
      }
    }
    
});

function doSwatchAjaxItem(data, current_handle, el_handle) {
     //var obj = jQuery.parseJSON(data);

     try {
        if (typeof data === 'string' && data.trim().startsWith('<')) {
          //throw new Error('Received HTML instead of JSON');
        }
        obj = JSON.parse(data);
      } catch (e) {
        //console.warn('Skipping invalid or missing product swatch data for:', el_handle);
        return;
      }

     if(obj.background_type == 'image') {
        var background = "background-image: url("+obj.background_swatch+")";
     } else {
        var background = "background-color: "+obj.background_swatch+"";
     }
     if (current_handle == el_handle) {
        var class_active = "active";
     } else {
        var class_active = "";
     }

     var sizeVariantsJson = '[]';

    if (obj.size_variants && Array.isArray(obj.size_variants)) {
      sizeVariantsJson = JSON.stringify(obj.size_variants).replace(/"/g, '&quot;');
    } 
    
    var imagesJson = '[]';
    if (obj.images && Array.isArray(obj.images)) {
        imagesJson = JSON.stringify(obj.images).replace(/"/g, '&quot;');
    }

     var swatch_button = `<a 
            href="javascript:void(0);"
            data-href=${JSON.stringify(obj.url)}
            data-swatch-variants 
            title=${obj.swatch_color}
            data-primary-bgset="${obj.primary_image}"
            data-secondary-bgset="${obj.second_image}"
            data-aspect-ratio=${obj.aspect_ratio}
            data-product='${JSON.stringify({ title: obj.title, url: obj.url, price: obj.price, compare_at_price: obj.compare_at_price, discount_percent: obj.discount_percent })}'
            data-size-variants="${sizeVariantsJson}"
            data-images="${imagesJson}"
            class="js-no-transition swatch"
            style="${background}"
            >`;
      $('.ag-swatch-collection[data-handle="'+el_handle+'"]:empty').append(swatch_button);
}


function doSwatchAjax($el) {
    var $el_handle = $el.data("handle");
    var $current_handle = $el.data("currenthandle");
    $.ajax({
      url: '/products/'+$el_handle+'?view=json',
      cache: true,
      success: function(data) {
        doSwatchAjaxItem(data, $current_handle, $el_handle);

      },
      error: function(jqXHR, textStatus, errorThrown) {
        //console.error("AJAX error loading product swatch:", textStatus, errorThrown);
         // do nothing
      }
   });
}
theme.preorderModal = function() {
    
    var selectors = {
      triggers: 'a.open-product-preorder-modal'
    };
  
    if (!$(selectors.triggers).length) {
      return;
    }
  
    var modal = new theme.Modals('PreorderModal', 'preorder-modal', {
      closeOffContentClick: true,
      solid: true
    });
   
    // We have at least one video that may open in a modal. Prep YouTube API
    $('body').on('click', selectors.triggers, function() {
      modal.open();
    });
 
  };
  
theme.inIframe = function() {
  try {
    return parent.document.location.hostname !== document.location.hostname;
  } catch (e) {
    return true;
  }
}

theme.config = {
  bpSmall: false,
  hasSessionStorage: true,
  mediaQuerySmall: 'screen and (max-width: 589px)',
  mediaQueryMediumUp: 'screen and (min-width: 590px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch: false,
  isIframe: theme.inIframe()
};

function onYouTubeIframeAPIReady() {
  theme.config.youTubeReady = true;
  $('body').trigger('youTubeReady');
}

function loadYouTube() {
  if (theme.config.youtubeReady) {
    return;
  }

  var tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

function loadVimeo() {
  if (theme.config.vimeoLoading) {
    return;
  }

  if (!theme.config.vimeoReady) {
    theme.config.vimeoLoading = true;
    var tag = document.createElement('script');
    tag.src = "https://player.vimeo.com/api/player.js";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // Because there's no way to check for the Vimeo API being loaded
    // asynchronously, we use this terrible timeout to wait for it being ready
    checkIfVimeoIsReady()
      .then(function() {
        theme.config.vimeoReady = true;
        theme.config.vimeoLoading = false;
        $('body').trigger('vimeoReady');
      })
      .fail(function() {
        // No vimeo API to talk to
      });
  }
}

function checkIfVimeoIsReady() {
  var deferred = $.Deferred();
  var wait;
  var timeout;

  wait = setInterval(function() {
    if (!Vimeo) {
      return;
    }

    clearInterval(wait);
    clearTimeout(timeout);
    deferred.resolve();
  }, 500);

  timeout = setTimeout(function() {
    clearInterval(wait);
    deferred.reject();
  }, 4000); // subjective. test up to 8 times over 4 seconds

  return deferred;
}

theme.init = function() {
  theme.setGlobals();
  theme.pageTransitions();
  theme.initQuickShop();
  theme.videoModal();
  theme.preorderModal();
  theme.articleImages.init();
  theme.backButton.init();
  theme.customerTemplates.init();
  theme.collapsibles.init();

  slate.rte.wrapTable();

  AOS.init({
    easing: 'ease-out-quad',
    once: true,
    offset: 60
  });
};

theme.setGlobals = function() {
  theme.config.hasSessionStorage = theme.isSessionStorageSupported() || theme.config.isIframe;

  window.addEventListener('touchstart', function onFirstTouch() {
    theme.config.isTouch = true;
    window.removeEventListener('touchstart', onFirstTouch, false);
    $('body').addClass('supports-touch');
  });

  enquire.register(theme.config.mediaQuerySmall, {
    match: function() {
      theme.config.bpSmall = true;
      $('body').trigger('matchSmall');
    },
    unmatch: function() {
      theme.config.bpSmall = false;
      $('body').trigger('unmatchSmall');
    }
  });

  enquire.register(theme.config.mediaQueryMediumUp, {
    match: function() {
      $('body').trigger('matchLarge');
    },
    unmatch: function() {
      $('body').trigger('unmatchLarge');
    }
  });
};

theme.loadImageSection = function($container) {
  // Wait until images inside container have lazyloaded class
  function setAsLoaded() {
    $container.removeClass('loading loading--delayed').addClass('loaded');
  }

  function checkForLazyloadedImage() {
    return $container.find('.lazyloaded').length;
  }

  // If it has SVGs it's in the onboarding state so set as loaded
  if ($container.find('svg').length) {
    setAsLoaded();
    return;
  };

  if (checkForLazyloadedImage() > 0) {
    setAsLoaded();
    return;
  }

  var interval = setInterval(function() {
    if (checkForLazyloadedImage() > 0) {
      clearInterval(interval);
      setAsLoaded();
    }
  }, 80);
}

theme.isSessionStorageSupported = function() {
  // Return false if we are in an iframe without access to sessionStorage
  if (window.self !== window.top) {
    return false;
  }

  var testKey = 'test';
  var storage = window.sessionStorage;
  try {
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
};

theme.isElementVisible = function($el, threshold) {
  if ($el && $el[0]) {
    var rect = $el[0].getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    threshold = threshold ? threshold : 0;
  
    return (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <= (windowHeight + threshold) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
};

theme.pageTransitions = function() {
  if ($('body').data('transitions') == true) {

    // Hack test to fix Safari page cache issue.
    // window.onpageshow doesn't always run when navigating
    // back to the page, so the unloading class remains, leaving
    // a white page. Setting a timeout to remove that class when leaving
    // the page actually finishes running when they come back.
    if (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)) {
      $('a').on('click', function() {
        window.setTimeout(function() {
          $('body').removeClass('unloading');
        }, 1200);
      });
    }

    // Add disable transition class to malito, anchor, and YouTube links
    $('a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"]').each(function() {
      $(this).addClass('js-no-transition');
    });

    $('a:not(.js-no-transition)').bind('click', function(evt) {
      if (evt.metaKey) return true;
      evt.preventDefault();
      $('body').addClass('unloading');
      var src = $(this).attr('href');
      window.setTimeout(function() {
        location.href = src;
      }, 50);
    });

    $('.mobile-nav__link').bind('click', function() {
        theme.NavDrawer.close();
    });
  }
};

window.onpageshow = function(evt) {
  // Removes unload class when returning to page via history
  if (evt.persisted) {
    $('body').removeClass('unloading');
  }
};


$(document).ready(function() {
  theme.init();

  window.sections = new theme.Sections();
  sections.register('header-section', theme.HeaderSection);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('video-section', theme.VideoSection);
  sections.register('product', theme.Product);
  sections.register('product-template', theme.Product);
  sections.register('collection-template', theme.Collection);
  sections.register('featured-content-section', theme.FeaturedContentSection);
  sections.register('testimonials', theme.Testimonials);
  sections.register('instagram', theme.Instagram);
  sections.register('newsletter-popup', theme.NewsletterPopup);
  sections.register('fading-images', theme.FadingImages);
  sections.register('map', theme.Maps);
  sections.register('blog', theme.Blog);
  sections.register('photoswipe', theme.Photoswipe);

  util.datatoggle.init();

  if(Shopify.shop == 'bec-and-bridge-au.myshopify.com') {
    var currency = $('span.money').attr("data-currency")

    if(currency == 'NZD') {
      $('.js-price-currency').text('NZ')
    } else {
      $('.js-price-currency').text('')
    }
  
    $('#CurrencyPicker-header').on('change', function() {
      var currency = $('span.money').attr("data-currency")
  
      if(currency == 'NZD') {
        $('.js-price-currency').text('NZ')
      } else {
        $('.js-price-currency').text('')
      }
    });
  
    setTimeout(function(){ 
      var currency = $('span.money').attr("data-currency")

      if(currency == 'NZD') {
        $('.js-price-currency').text('NZ')
        $('.js-ajaxcart__price .js-price-currency').text('NZ')
      } else {
        $('.js-price-currency').text('')
        $('.js-ajaxcart__price .js-price-currency').text('')
      }
    }, 1000);
  } else {
    var currency = $('span.money').attr("data-currency")

    if(currency == 'USD') {
      $('.js-price-currency').text('US')
    } else {
      $('.js-price-currency').text('')
    }
  
    $('#CurrencyPicker-header').on('change', function() {
      var currency = $('span.money').attr("data-currency")
  
      if(currency == 'USD') {
        $('.js-price-currency').text('US')
      } else {
        $('.js-price-currency').text('')
      }
    });
  
    setTimeout(function(){ 
      var currency = $('span.money').attr("data-currency")
      if(currency == 'USD') {
        $('.js-price-currency').text('US')
        $('.js-ajaxcart__price .js-price-currency').text('US')
      } else {
        $('.js-price-currency').text('')
        $('.js-ajaxcart__price .js-price-currency').text('')
      }
    }, 1000);
  }

  $(".product-sizeguide-modal__close").on( "click", function() {
    window.util.datatoggle.resetSingleTab();
  });

});

//GEN-9725: Full page carousel

var args_desktop_full_page_carousel = {
  accessibility: true,
  arrows: true,
  dots: true,
  draggable: true,
  touchThreshold: 5,
  pauseonHover: false,
  autoplay: false,
  infinite: false
}

var args_mobile_full_page_carousel = {
  accessibility: true,
  arrows: true,
  dots: true,
  draggable: true,
  touchThreshold: 5,
  pauseonHover: false,
  autoplay: false,
  infinite: false,
  adaptiveHeight: true
}

// BCBR-26: Collection page slider

var args_mobile = {
  accessibility: true,
  arrows: false,
  dots: false,
  draggable: true,
  swipe: false,
  touchThreshold: 5,
  pauseonHover: false,
  autoplay: false,
};

var args_desktop = {
  accessibility: true,
  arrows: false,
  dots: false,
  draggable: false,
  touchThreshold: 5,
  pauseonHover: false,
  autoplay: false,
};

var product_carousel_args_desktop = {
  accessibility: true,
  arrows: true,
  dots: false,
  draggable: true,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  adaptiveHeight: false,
  lazyLoad: 'ondemand',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1        
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
        arrows: false,
        touchThreshold: 200,
        variableWidth: true,
        infinite: false
      }
    }
  ]
};

var products_slider_args = {
  accessibility: true,
  arrows: true,
  dots: false,
  draggable: true,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  adaptiveHeight: false,
  lazyLoad: 'ondemand',
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1,
        arrows: false,
        touchThreshold: 200,
        variableWidth: false,
        infinite: false      
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
        arrows: false,
        touchThreshold: 200,
        variableWidth: true,
        infinite: false
      }
    }
  ]
};

var product_carousel_args_mobile = {
  accessibility: true,
  arrows: false,
  dots: false,
  draggable: true,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  adaptiveHeight: false
};

var splitscreen_args_mobile = {
  accessibility: true,
  arrows: false,
  dots: true,
  draggable: true,
  touchThreshold: 5,
  pauseonHover: false,
  autoplay: true,
};

const $status = $('.pagingInfo')
const $slickElementDesktop = $('#full-page-carousel-desktop')

$slickElementDesktop.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
  //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
  if(!slick.$dots){
  	return;
  }
  
  var i = (currentSlide ? currentSlide : 0) + 1;
  $status.text(i + '/' + (slick.$dots[0].children.length));
});

const $slickElementMobile = $('#full-page-carousel-mobile')

$slickElementMobile.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
  //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
  if(!slick.$dots){
  	return;
  }
  
  var i = (currentSlide ? currentSlide : 0) + 1;
  $status.text(i + '/' + (slick.$dots[0].children.length));
});

$(window).resize(function () {
  var productCarouselCurrentIndex;
  if ($(window).width() < 590 ) {    
    if ($('#full-page-carousel-mobile').hasClass('slick-initialized')) {
      $('#full-page-carousel-mobile').slick('unslick');
    }
  } else {
    if ($('#full-page-carousel-desktop').hasClass('slick-initialized')) {
      $('#full-page-carousel-desktop').slick('unslick');
    }
    $('#full-page-carousel-desktop').slick({ ...args_desktop_full_page_carousel,
      prevArrow: prevSVGWhite,
      nextArrow: nextSVGWhite
    });    
  }
})

$(document).ready( function() {
  if (!location.href.includes("/cart")){
    localStorage.setItem("previous_url", location.href);
  }
  if ($(window).width() < 590 ) {
    $('#full-page-carousel-mobile').slick({ ...args_mobile_full_page_carousel,
      prevArrow: prevSVGWhite,
      nextArrow: nextSVGWhite
    });
  }
  else {
    $('#full-page-carousel-desktop').slick({ ...args_desktop_full_page_carousel,
      prevArrow: prevSVGWhite,
      nextArrow: nextSVGWhite
    });    
  }
  $('.slick-product-carousel').slick({ ...product_carousel_args_desktop,
    prevArrow: `<img class="custom-prev-arrow" src="${$('.slick-product-carousel').attr('data-prev-arrow')}" alt="Previous">`,
    nextArrow: `<img class="custom-next-arrow" src="${$('.slick-product-carousel').attr('data-next-arrow')}" alt="Next">`
  });

  $('.slick-products-slider').each(function () {
    const prevArrow = $(this).attr('data-prev-arrow');
    const nextArrow = $(this).attr('data-next-arrow');

    $(this).slick({
      ...products_slider_args,
      prevArrow: `<img class="custom-prev-arrow" src="${prevArrow}" alt="Previous">`,
      nextArrow: `<img class="custom-next-arrow" src="${nextArrow}" alt="Next">`
    });
  });

  
  if ($(window).width() < 590 ) {
    $('.splitscreen-slick-container').slick(splitscreen_args_mobile);
  }
  else {
    $('.splitscreen-slick-container').slick(splitscreen_args_mobile);
  }

  // Product carousel
  $('.product-carousel-container').each(function(key, item) {
    const sliderId = `#${$(this).attr('id')}`;
    $(sliderId).slick({
      accessibility: true,
      arrows: true,
      dots: false,
      autoplay: false,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 589,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });

    $(sliderId).on('afterChange', function(event, slick, currentSlide) {
      if (slick.currentSlide >= slick.slideCount - slick.options.slidesToShow) {
        $(sliderId).removeClass('products-loaded').addClass('products-loaded')
      }
    });
  
    $(sliderId).on('swipe', function(event, slick, direction) {
      if (direction == 'right' && !$(sliderId).hasClass('products-loaded')) {
        setTimeout(function() {
          $(sliderId).slick('slickNext')
        }, 500)
      }
    });
  });

    // Announcement bar slider

    $('.announcement-slider').slick({
      dots: false,
      infinite: true,
      slidesToShow: 1,
      adaptiveHeight: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 3000
    });

  // Logo carousel
  
  $('.logo-carousel').each(function(key, item) {
    const logoSliderId = `#${$(this).attr('id')}`;
    $(logoSliderId).slick({
      accessibility: true,
      arrows: true,
      dots: false,
      autoplay: false,
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow: `<img class="logo-prev-arrow" src="${$(logoSliderId).attr('data-prev-arrow')}" alt="Previous">`,
      nextArrow: `<img class="logo-next-arrow" src="${$(logoSliderId).attr('data-next-arrow')}" alt="Next">`,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 589,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
    
  });

  // Balance check
      $('body').on('click', ".gift-balance-box button", function(e) {
          e.preventDefault();

          var $form = $('.balance-check-form');
          let giftCardNo = $('#gift_card_number').val();
          let errorMessage = $form.find('.form-error');
          let successMessage = $form.find('.form-success');
          let giftCardPin = $('#gift_card_pin').val();
          let shopName = Shopify.shop;
          let endpoint = "https://shopifybcbap21app.testarc.com.au/giftcard/get?shop=";

          if (Shopify.shop == 'bec-bridge-development.myshopify.com') {
            endpoint = "https://shopifybcbap21app-dev.testarc.com.au/giftcard/get?shop=";
          };

          if (giftCardNo == '' || giftCardPin == '') {
              errorMessage.text(errorMessage.data('error'));
              errorMessage.show();
              
          }else{

              var $data = {
                "voucher": {
                  "giftvoucher": giftCardNo,
                  "pin": giftCardPin
                }
              };

              $.ajax({
                url: endpoint + shopName,
                dataType: 'json',
                cache: false,
                type: 'post',
                data: $data,
                beforeSend: function() {
                
                },
                success: function(itemData) {

                    if (itemData.success) {
                      errorMessage.hide();
                      successMessage.find('.balance').text(itemData.gift_card.balance);
                      successMessage.show();

                    }else{
                      successMessage.hide();
                      errorMessage.text(itemData.message);
                      errorMessage.show();
                    }
                 
                },
                error: function(XMLHttpRequest) { 
                  var response = eval('(' + XMLHttpRequest.responseText + ')');
                  response = response.message;
                  console.error(response);

                }
              });

          }





      });

});

// Instant Search Native Search //

function instantSearchSuggestion(searchQuery) {

  $.ajax({
    "url": `/search/suggest.json?q=${searchQuery}&resources[type]=product&resources[limit]=4&resources[options][fields]=title,product_type,variants.title,tag,body`, 
    "type": "GET",
    "dataType": "json",
  }).then(( data ) => {

    const products = data && data.resources.results.products;

    if (products.length == 0) {
      $('.site-header-sticky').css('height', '220px');
      $('.site-header').css('height', '100vh');

      const searchResult = document.querySelector('.site-header__search-results');
      const searchResultTitle  = document.createElement("span");
      const searchResultAllProductLink  = document.createElement("a");
      searchResultAllProductLink.classList.add('site-header__search-no-results-link');

      const searchResultDisplay = document.querySelector('.site-header__search-results-container');
      searchResultDisplay.classList.add('active');
      searchResultDisplay.classList.add('noresults_container');
      document.querySelector('.site-header__search_collections').classList.add('active');
      
      searchResultTitle.classList.add('site-header__search-no-results-title');
      searchResultTitle.innerHTML = '<u><a href="/search?q=' + searchQuery + '&type=product">See results for ' + '<b>' +searchQuery + '</b></a></u>.' ;

      const arrowLink = document.createElement("i");
      arrowLink.classList.add('site-header__results-arrow');
   
      const allProductsLink = '/collections/all';
      searchResultAllProductLink.setAttribute('href', allProductsLink);
      
      searchResultAllProductLink.innerText = 'See all products';
      searchResultAllProductLink.appendChild(arrowLink);
  
      const searchResultContainer  = document.createElement("div");
      searchResultContainer.classList.add('site-header__search-results-main');
      searchResult.innerHTML = '';
      searchResult.appendChild(searchResultTitle);
      searchResult.appendChild(searchResultAllProductLink);
      searchResult.appendChild(searchResultContainer);
  
     
    }
    else {

      $('.site-header-sticky').css('height', '80vh');
      $('.site-header').css('height', '100vh');

      const searchResult = document.querySelector('.site-header__search-results');
      const currency = searchResult.getAttribute('data-currency');

      const search_headerRow = document.createElement("div");
      search_headerRow.classList.add("site-header__search-results-title");

      const titleSpan = document.createElement("span");
      titleSpan.classList.add("search-results-title");
      titleSpan.innerText = "Products:";

      const viewResults = document.createElement("a");
      viewResults.classList.add("search-results-view");
      viewResults.innerText = "View results";
      viewResults.href = `/search?q=${encodeURIComponent(searchQuery)}&type=product`;

      search_headerRow.appendChild(titleSpan);
      search_headerRow.appendChild(viewResults);
  
      const searchResultContainer  = document.createElement("div");
      searchResultContainer.classList.add('site-header__search-results-main');
      searchResult.innerHTML = '';
      searchResult.appendChild(search_headerRow);
      searchResult.appendChild(searchResultContainer);
  
      const searchResultDisplay = document.querySelector('.site-header__search-results-container');
      
      searchResultDisplay.classList.add('active');
      searchResultDisplay.classList.remove('noresults_container');
      document.querySelector('.site-header__search_collections').classList.remove('active');
    
      data.resources.results.products.forEach((product) => {
      
        const main = document.createElement("div");
        main.classList.add('site-header_search-results-products');
        main.setAttribute('id', product.id);
        const anchor = document.createElement("a");
        const image = document.createElement("img");
        const info = document.createElement("div");
        const priceContainer = document.createElement("div");
        const title = document.createElement("span");
        const price = document.createElement("span");
    
        const tag = document.createElement("div");
           
        title.innerText = product.title;
        price.innerText = `${currency}${product.price}`;
  
        info.classList.add('site-header_search-results-products-info');
        title.classList.add('site-header_search-results-products-info__title');
        tag.classList.add('site-header_search-results-products-info__tag');
        price.classList.add('site-header_search-results-products-info__price');
        priceContainer.classList.add('site-header_search-results-products-info__price-container');
    
        anchor.classList.add('product-ez-image', `ratio-${theme.settings.ImageRatio}`);
        anchor.setAttribute('href', product.url);
  
        image.classList.add('grid-product__image');
        image.setAttribute('src', product.image);
  
  
        info.appendChild(title);
        priceContainer.appendChild(price);

        if (product.compare_at_price_max > 0) {
          const priceCompare = document.createElement("span");
          priceCompare.classList.add('site-header_search-results-products-info__discounted-price');
          priceCompare.innerText = `${currency}${product.compare_at_price_max}`;
          priceContainer.appendChild(priceCompare);
        }

        info.appendChild(priceContainer);
  
        info.appendChild(tag);
        anchor.appendChild(image);
        main.appendChild(anchor);
        main.appendChild(info);
        searchResultContainer.appendChild(main);
        //console.log(product);
      });
    }
  }).catch((error) => {
    console.log(error)
  }).then(() => {
    const searchedProducts = document.querySelectorAll('.site-header_search-results-products');
    if (!searchedProducts.length) {
      return
    }
  
    searchedProducts.forEach(productElement => {
      const productId = productElement.getAttribute('id')
      //console.log(productId);
      $.ajax({
        "url": `https://${Shopify.shop}/api/graphql`, 
        "data": 
        `
          {
            nodes(ids: ["gid://shopify/Product/${productId}"]) {
              id
              ... on Product {
                title
                vendor
                productTags: metafield(namespace: "global", key: "product_tags") {
                  key
                  value   
                }                
                badge_2: metafield(namespace: "custom", key: "badge_2") {
                  key
                  value
                }
                badge_3: metafield(namespace: "custom", key: "badge_3") {
                  key
                  value
                }
              }
            }
          }
        `,
        "type": "POST",
        "headers": {
          'Content-Type': 'application/graphql',
          'X-Shopify-Storefront-Access-Token': getAccessToken()
        },
        success: (data) => {
          //console.log(data);
          const productTag = data.data?.nodes?.[0]?.productTags?.value
          const badge_2 = data.data?.nodes?.[0]?.badge_2?.value
          const badge_3 = data.data?.nodes?.[0]?.badge_3?.value
          if (!productTag) return

          //console.log('');
          const productElement = document.getElementById(productId)
          if (!productElement) return
  
          const productInfoElement = productElement.querySelector('.site-header_search-results-products-info__tag')
          /*
          const productTagElement = document.createElement('div')
          const content = document.createTextNode(productTag)
          productTagElement.appendChild(content)
          productTagElement.className = 'custom-product-tag'
          
          productInfoElement.appendChild(productTagElement)
          */
          // Array of badges to create
          const badges = [
            { value: productTag, className: 'custom-product-tag' },
            { value: badge_2, className: 'custom-product-tag' },
            { value: badge_3, className: 'custom-product-tag' }
          ]
          
          // Create elements for each badge that has a value
          productInfoElement.innerHTML = '';
          badges.forEach(badge => {
            if (badge.value) {
              const badgeElement = document.createElement('div')
              const content = document.createTextNode(badge.value)
              badgeElement.appendChild(content)
              badgeElement.className = badge.className
              productInfoElement.appendChild(badgeElement)
            }
          })
          
        }
      })
    })
  });

}



/* ================ COLLECTION PAGE ================ */

// Product Grid Changes

function handleSwatchClick(swatchParent){
  if(swatchParent) {
    let swatch = $(swatchParent).find("a");
    swatch.on("click", function(e){
      e.preventDefault();
      const src = $(swatch).attr("href");
      setTimeout(() => {
        location.href = src;
      }, 50)
    })
  }
}

function getActiveSwatch(swatch) {
  const productItem = $(swatch).closest(".grid__item");
  const productContent = $(productItem).find('.grid-product__content');
  const productImage = $(productContent).children('.grid-product__image-mask');
  let linkProduct;
  if (($("body").hasClass("template-collection") || $("body").hasClass("template-search")) && $("[data-grid-swatch-wrapper]").length > 0){  
    linkProduct = $(productImage).find('.grid-product__link.slick-current');
  }
  else{
    linkProduct = $(productImage).children('.grid-product__link');
  }
  const productSrc = $(linkProduct).attr("href").split("/");
  const swatchSrc = $(swatch).find("a").attr("data-href");
  const productHandle = productSrc[productSrc.length - 1];
  let swatchHandle = "";
  if (swatchSrc) {
    const swatchHandleArray = swatchSrc.split("/");
    swatchHandle = swatchHandleArray[swatchHandleArray.length - 1];
  }
  
  
  if (productHandle === swatchHandle) {
    $(swatch).find("a").addClass("active");
  } else {
    return 
  }
}

/*============================================================================
  Utilities
==============================================================================*/

function waitForAddedNode(params) {
  new MutationObserver(function() {
      var el = document.querySelector(params.class);
      if (el) {
        this.disconnect();
        params.done(el);
      }
    }).observe(document, {
      subtree: true,
      childList: true,
  });
};

// For Countdown
const countdownDate = document.querySelector('[name="countdown_date"]')?.value
const countriesContainer = document.querySelectorAll('.countdown_country')
const second = 1000
const minute = second * 60
const hour = minute * 60
const day = hour * 24

const countdownInterval = setInterval(countdown, 1000)

function countdown () {
  const countDate = new Date(countdownDate).getTime()
  const dateNow = new Date().getTime()
  let gap = countDate - dateNow

  const prependSingleNumber = (number) => {
    if (number < 10) {
      return `0${number}`
    } else {
      return number
    }
  }

  
  if (gap == 0 || gap < 1000) {
    clearInterval(countdownInterval)
    gap = 0
  }

  $('.days').html(prependSingleNumber(Math.floor(gap / day)))
  $('.hours').html(prependSingleNumber(Math.floor((gap % day) / hour)))
  $('.minutes').html(prependSingleNumber(Math.floor((gap % hour) / minute)))
  $('.seconds').html(prependSingleNumber(Math.floor((gap % minute) / second)))
}

if (countriesContainer.length > 0) {
  for (const country of countriesContainer) {
    const dateTime = country.querySelector('.date-time')
    if(dateTime){
    const timezoneID = country.querySelector('[name="timezone_id"]')?.value
    const countDate = new Date(countdownDate)
    let dateTimeContent = ''
    
    const timeZone = getTimezoneAbbr(timezoneID)
    const countDateYear = countDate.toLocaleString('default', { year: 'numeric', timeZone: timezoneID })
    const countDateMonth = countDate.toLocaleString('default', { month: '2-digit', timeZone: timezoneID })
    const countDateDay = countDate.toLocaleString('default', { day: '2-digit', timeZone: timezoneID })
    const countDateTime = countDate.toLocaleString('default', { timeStyle: 'short', timeZone: timezoneID })
    dateTimeContent = `${countDateYear}/${countDateMonth}/${countDateDay} @ ${countDateTime} ${timeZone}`
    dateTime.innerHTML = dateTimeContent
    }
  }
}

function getTimezoneAbbr (timezoneID) {
  const date = new Date();
  // Set the time zone identifier
  const timeZoneIdentifier = timezoneID;
  // Get the time string in the specified time zone
  const timeZoneAbbr = date.toLocaleTimeString('en-US', { timeZone: timeZoneIdentifier, timeZoneName: 'short' }).split(' ')[2];

  return timeZoneAbbr
}

//Quick add button
document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll('.ezr_size_swatches').forEach(function(wrapper) {
    const swatches = wrapper.querySelectorAll('.ezr_add_to_cart_swatch');

    let selectedVariantId = null;

    const activeSwatch = wrapper.querySelector('.ezr_add_to_cart_swatch.active');
    if (activeSwatch) {
        selectedVariantId = activeSwatch.getAttribute('data-id');
    }

    wrapper.addEventListener('click', function(event) {
        const clicked = event.target.closest('.ezr_add_to_cart_swatch');

        if (clicked && wrapper.contains(clicked)) {
            const swatches = wrapper.querySelectorAll('.ezr_add_to_cart_swatch');
            
            swatches.forEach(s => s.classList.remove('active'));
            clicked.classList.add('active');
            selectedVariantId = clicked.getAttribute('data-id');
        }
    });

    const addButton = wrapper.querySelector('.ezr_add_button');
    if (addButton) {
      addButton.addEventListener('click', function () {
        if (!selectedVariantId) {          
          return;
        }

        addButton.disabled = true;
        //addButton.classList.add('ezr--loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: selectedVariantId,
            quantity: 1
          })
        })
        .then(res => res.json())
        .then(data => {
          //console.log('Added to cart:', data);
          $('body').trigger('added.ajaxProduct');

        })
        .catch(err => {
          console.error('Add to cart error:', err);
        })
        .finally(() => {
          addButton.disabled = false;
          //addButton.classList.remove('ezr--loading');
        });
      });
    }
  });
});

//collection images slider
document.addEventListener("DOMContentLoaded", function () {
  const collectionImageSliderId = `.grid-slick-slider`;
  collectionImagesSlider(collectionImageSliderId);
});

function collectionImagesSlider(elem){
  var $slider = $(elem);

  $slider.slick({
    accessibility: true,
    arrows: true,
    dots: false,
    autoplay: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,    
    lazyLoad: 'progressive',
    prevArrow: `<img class="sslick-prev-arrow" src="${$slider.attr('data-prev-arrow')}" alt="Previous">`,
    nextArrow: `<img class="sslick-next-arrow" src="${$slider.attr('data-next-arrow')}" alt="Next">`
  });

}

//cart code

// related products - product recommendations
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      const responseHTML = request.responseText;
      const responseDiv = document.createElement('div');
      responseDiv.innerHTML = responseHTML;
      const productRecommendations = responseDiv.querySelector('.product-recommendations');
      const productslides = responseDiv.querySelectorAll('.grid-product').length;
      
      if (productRecommendations) {
        const extractedHTML = productRecommendations.innerHTML;        
        const RecomElement = document.querySelector('.product-recommendations');
        if (RecomElement) {
          RecomElement.innerHTML = extractedHTML;
          agswatchcollection();
          relatedSlider(productslides);
        }
      }     
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

function relatedSlider(slideCount){
  const relatedSliderId = `.related-products-wrapper`;
  if(slideCount < 4){
   document.querySelector(relatedSliderId).classList.add('related-less-slides');
  }
  $(relatedSliderId).slick({
    accessibility: true,
    arrows: true,
    dots: false,
    autoplay: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,    
    prevArrow: `<img class="sslick-prev-arrow" src="${$(relatedSliderId).attr('data-prev-arrow')}" alt="Previous">`,
    nextArrow: `<img class="sslick-next-arrow" src="${$(relatedSliderId).attr('data-next-arrow')}" alt="Next">`,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 589,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}

function cartRelatedSlider(){
  const relatedMain = document.querySelector('.cart-related-main');
  relatedMain.style.visibility = 'hidden';
  relatedMain.style.display = 'block';

  setTimeout(() => {
  if ($('.cart-related-items').hasClass('slick-initialized')) {
    $('.cart-related-items').slick('unslick');
  }

  $('.cart-related-items').slick({
    infinite: true,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    variableWidth: true,
    prevArrow: `<button type="button" class="slick-prev"><img src="${$(relatedMain).attr('data-prev-arrow')}" alt="Previous"/></button>`,
    nextArrow: `<button type="button" class="slick-next"><img src="${$(relatedMain).attr('data-next-arrow')}" alt="Next"/></button>`,
  });

  relatedMain.style.visibility = 'visible';
  }, 200);
}

$(document).on('click', '.cart-rp-variant', function (e) {
  e.preventDefault();
  //const variantId = $(this).data('variant-id');
  const variantId = $(this).parents(".cart-rp-variants").find(".cart-rp-variant-dropdown").val();

  if (!variantId) return;

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: variantId
    },
    dataType: 'json',
    success: function (response) {
      //console.log('Product added:', response);
      $('body').trigger('added.ajaxProduct');
    },
    error: function (err) {
      //console.error('Error adding to cart:', err);
    }
  });
});